webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(301);


/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	run.$inject = ["authManager", "$rootScope", "$state", "Authentication"];
	__webpack_require__(302);
	
	var _angular = __webpack_require__(305);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularAnimate = __webpack_require__(307);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	var _angularUiRouter = __webpack_require__(309);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(310);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	var _oclazyload = __webpack_require__(312);
	
	var _oclazyload2 = _interopRequireDefault(_oclazyload);
	
	var _angularBlockUi = __webpack_require__(313);
	
	var _angularBlockUi2 = _interopRequireDefault(_angularBlockUi);
	
	var _blockUI = __webpack_require__(314);
	
	var _blockUI2 = _interopRequireDefault(_blockUI);
	
	var _angularJwt = __webpack_require__(315);
	
	var _angularJwt2 = _interopRequireDefault(_angularJwt);
	
	var _angularToastr = __webpack_require__(317);
	
	var _angularToastr2 = _interopRequireDefault(_angularToastr);
	
	var _angularLocalStorage = __webpack_require__(319);
	
	var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);
	
	var _authentication = __webpack_require__(321);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _collection = __webpack_require__(342);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _email = __webpack_require__(343);
	
	var _email2 = _interopRequireDefault(_email);
	
	var _config = __webpack_require__(344);
	
	var _config2 = _interopRequireDefault(_config);
	
	__webpack_require__(345);
	
	__webpack_require__(349);
	
	__webpack_require__(350);
	
	__webpack_require__(352);
	
	__webpack_require__(354);
	
	__webpack_require__(311);
	
	__webpack_require__(361);
	
	__webpack_require__(363);
	
	__webpack_require__(318);
	
	__webpack_require__(365);
	
	__webpack_require__(368);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import 'ui-select/dist/select.min.js';
	
	// window.$ = window.jQuery = require('jquery');
	_angular2.default.module('contentBank', [_angularUiRouter2.default, _oclazyload2.default, _angularUiBootstrap2.default, _angularBlockUi2.default, _angularJwt2.default, _angularToastr2.default, _angularLocalStorage2.default, _angularAnimate2.default, 'ui.select']).config(["$locationProvider", "$stateProvider", "$urlRouterProvider", "jwtOptionsProvider", "$httpProvider", "blockUIConfig", function ($locationProvider, $stateProvider, $urlRouterProvider, jwtOptionsProvider, $httpProvider, blockUIConfig) {
	    "ngInject";
	
	    blockUIConfig.template = _blockUI2.default;
	    blockUIConfig.delay = 0;
	
	    $locationProvider.html5Mode(true).hashPrefix('!');
	
	    $stateProvider
	    // root state for users that are NOT logged in
	    .state('root', {
	        abstract: true,
	        template: '<div ui-view="page"></div>'
	    })
	    // root state for users that are logged in
	    .state('user', {
	        abstract: true,
	        template: '<user-layout class="full-height-element layout"></user-layout>',
	        data: {
	            requiresLogin: true
	        },
	        resolve: {
	            lazyLoad: ["$q", "$ocLazyLoad", function lazyLoad($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(1, function () {
	                    var name = __webpack_require__(369).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }]
	        }
	    }).state('user.dashboard', {
	        url: '/dashboard',
	        views: {
	            'page@user': {
	                template: '<dashboard></dashboard>'
	
	            }
	        },
	        data: {
	            requiresLogin: true
	        },
	
	        resolve: {
	            loadDashboard: ["$q", "$ocLazyLoad", function loadDashboard($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(2, function () {
	                    var name = __webpack_require__(376).default.name;
	                    // const productMediaListComponent = require('./components/product-media/product-media.module.js').default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                        // return $ocLazyLoad.load({ productMediaListComponent });
	                    });
	                    // .then(function() {
	                    //     deferred.resolve();
	                    // });
	                });
	
	                return deferred.promise;
	            }],
	            loadProductMediaModule: ["$q", "$ocLazyLoad", function loadProductMediaModule($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(3, function () {
	
	                    var name = __webpack_require__(379).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }],
	            loadProductModule: ["$q", "$ocLazyLoad", function loadProductModule($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(4, function () {
	
	                    var name = __webpack_require__(407).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }]
	        }
	    }).state('root.login', {
	
	        //
	        // To lazy load a whole state of our app we need to add
	        // a resolve method.
	        url: '/login',
	        views: {
	            'page@root': {
	                template: '<login-page></login-page>'
	            }
	        },
	        resolve: {
	            lazyLoad: ["$q", "$ocLazyLoad", function lazyLoad($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(6, function () {
	                    var name = __webpack_require__(811).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }]
	        }
	    }).state('user.profile', {
	        url: '/profile',
	        views: {
	            'page@user': {
	                template: '<user-profile class="full-height-element"></user-profile>'
	            }
	        },
	        resolve: {
	            lazyLoad: ["$q", "$ocLazyLoad", function lazyLoad($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(8, function () {
	                    var name = __webpack_require__(834).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }]
	        }
	    }).state('user.productCollection', {
	        url: '/product-collection',
	        views: {
	            'page@user': {
	                template: '<product-collection></product-collection>'
	            }
	        },
	        resolve: {
	            lazyLoad: ["$q", "$ocLazyLoad", function lazyLoad($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(9, function () {
	                    var name = __webpack_require__(844).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }]
	        }
	    }).state('user.reviewCollection', {
	        url: '/reviewCollection/:collectionId?overview',
	        params: {
	            overview: undefined
	        },
	        views: {
	            'page@user': {
	                template: '<review-collection></review-collection>'
	            }
	        },
	        resolve: {
	            lazyLoad: ["$q", "$ocLazyLoad", function lazyLoad($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(10, function () {
	                    var name = __webpack_require__(851).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }]
	        }
	    }).state('reviewDraftCollection', {
	        url: '/reviewCollection',
	        data: {
	            requiresLogin: true
	        },
	        views: {
	            '@': {
	                template: '<review-draft-collection></review-draft-collection>'
	            }
	        },
	        resolve: {
	            lazyLoad: ["$q", "$ocLazyLoad", function lazyLoad($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                !/* require.ensure */(function () {
	                    var name = 'contentBank.reviewDraftCollection';
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                }(__webpack_require__));
	
	                return deferred.promise;
	            }]
	        }
	    }).state('reviewPublishedCollection', {
	        url: '/reviewCollection',
	        data: {
	            requiresLogin: true
	        },
	        views: {
	            '@': {
	                template: '<review-published-collection></review-published-collection>'
	            }
	        },
	        resolve: {
	            lazyLoad: ["$q", "$ocLazyLoad", function lazyLoad($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                !/* require.ensure */(function () {
	                    var name = 'contentBank.reviewPublishedCollection';
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                }(__webpack_require__));
	
	                return deferred.promise;
	            }]
	        }
	    }).state('user.myUploads', {
	        url: '/my-uploads',
	        data: {
	            requiresLogin: true
	        },
	        views: {
	            'page@user': {
	                template: '<my-uploads></my-uploads>'
	            }
	        },
	        resolve: {
	            lazyLoad: ["$q", "$ocLazyLoad", function lazyLoad($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(13, function () {
	                    var name = __webpack_require__(886).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }]
	        }
	    }).state('admin', {
	        abstract: true,
	        data: {
	            requiresLogin: true
	        },
	        // data: {
	        //     requiresLogin: true
	        // },
	        views: {
	            '@': {
	                template: '<layout></layout>'
	            },
	            'sidebar@admin': {
	                template: '<sidebar></sidebar>'
	            },
	            'header@admin': {
	                template: '<header></header>'
	            }
	        },
	
	        resolve: {
	            loadSidebarComponent: ["$q", "$ocLazyLoad", function loadSidebarComponent($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(14, function () {
	                    var name = __webpack_require__(893).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }],
	            loadHeaderComponent: ["$q", "$ocLazyLoad", function loadHeaderComponent($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(16, function () {
	                    var name = __webpack_require__(1001).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }],
	            loadLayoutComponent: ["$q", "$ocLazyLoad", function loadLayoutComponent($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(17, function () {
	                    var name = __webpack_require__(1007).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }]
	        }
	    }).state('admin.uploader', {
	        url: '/admin-uploader',
	        data: {
	            requiresLogin: true,
	            header: 'Uploader'
	        },
	        views: {
	            'breadcrumb@admin': {
	                template: '\n                    '
	            },
	            'main@admin': {
	                template: '<admin-product-media-list></admin-product-media-list>'
	            }
	        },
	
	        resolve: {
	            loadUploaderInterface: ["$q", "$ocLazyLoad", function loadUploaderInterface($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(18, function () {
	                    var name = __webpack_require__(1012).default.name;
	                    // const productMediaListComponent = require('./components/product-media/product-media.module.js').default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                        // return $ocLazyLoad.load({ productMediaListComponent });
	                    });
	                    // .then(function() {
	                    //     deferred.resolve();
	                    // });
	                });
	
	                return deferred.promise;
	            }]
	        }
	
	    }).state('admin.uploader.addProductToCollection', {
	
	        url: '/add-to-collection',
	        data: {
	            requiresLogin: true,
	            header: 'Add Products to Collection'
	        },
	        views: {
	            'breadcrumb@admin': {
	                template: '\n                    '
	            },
	            'main@admin': {
	                template: '<admin-product-collection></admin-product-collection>'
	            }
	        },
	
	        resolve: {
	            loadAddProductsToCollectionComponent: ["$q", "$ocLazyLoad", function loadAddProductsToCollectionComponent($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(19, function () {
	                    var name = __webpack_require__(1039).default.name;
	                    // const productMediaListComponent = require('./components/product-media/product-media.module.js').default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                        // return $ocLazyLoad.load({ productMediaListComponent });
	                    });
	                    // .then(function() {
	                    //     deferred.resolve();
	                    // });
	                });
	
	                return deferred.promise;
	            }]
	        }
	
	    }).state('admin.uploader.reviewCollection', {
	        url: '/review-collection/:collectionId?overview',
	        data: {
	            requiresLogin: true,
	            header: 'Add Products to Collection'
	        },
	        params: {
	            overview: undefined
	        },
	        views: {
	            'breadcrumb@admin': {
	                template: '\n                    '
	            },
	            'main@admin': {
	                template: '<admin-review-collection></admin-review-collection>'
	            }
	        },
	        resolve: {
	            loadReviewCollectionComponent: ["$q", "$ocLazyLoad", function loadReviewCollectionComponent($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(21, function () {
	                    var name = __webpack_require__(1046).default.name;
	                    // const productMediaListComponent = require('./components/product-media/product-media.module.js').default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }]
	        }
	    }).state('admin.uploader.reviewDraftCollection', {
	        url: '/review-collection',
	        data: {
	            requiresLogin: true,
	            header: 'Add Products to Collection'
	        },
	        views: {
	            'breadcrumb@admin': {
	                template: '\n                    '
	            },
	            'main@admin': {
	                template: '<admin-review-draft-collection></admin-review-draft-collection>'
	            }
	            // resolve: {
	            //     lazyLoad($q, $ocLazyLoad) {
	            //         'ngInject';
	
	            //         const deferred = $q.defer();
	
	            //         require.ensure([], function() {
	            //             const name = 'contentBank.adminReviewDraftCollection';
	            //             $ocLazyLoad.load({ name }).then(function() {
	            //                 deferred.resolve();
	            //             });
	            //         });
	
	            //         return deferred.promise;
	            //     }
	            // }
	        } }).state('admin.uploader.reviewPublishedCollection', {
	        url: '/review-collection',
	        data: {
	            requiresLogin: true,
	            header: 'Add Products to Collection'
	        },
	        views: {
	            'breadcrumb@admin': {
	                template: '\n                    '
	            },
	            'main@admin': {
	                template: '<admin-review-published-collection></admin-review-published-collection>'
	            }
	            // resolve: {
	            //     lazyLoad($q, $ocLazyLoad) {
	            //         'ngInject';
	
	            //         const deferred = $q.defer();
	
	            //         require.ensure([], function() {
	            //             const name = 'contentBank.adminReviewPublishedCollection';
	            //             $ocLazyLoad.load({ name }).then(function() {
	            //                 deferred.resolve();
	            //             });
	            //         });
	
	            //         return deferred.promise;
	            //     }
	            // }
	        } }).state('admin.dashboard', {
	        url: '/admin-dashboard',
	        data: {
	            requiresLogin: true,
	            header: 'Filters'
	        },
	        views: {
	            'breadcrumb@admin': {
	                template: '\n                    '
	            },
	            'main@admin': {
	                template: '<admin-dashboard></admin-dashboard>'
	            }
	        },
	        resolve: {
	            loadDashboardComponent: ["$q", "$ocLazyLoad", function loadDashboardComponent($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(22, function () {
	                    var name = __webpack_require__(1072).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }]
	        }
	
	    }).state('admin.statistics', {
	        url: '/admin-statistics',
	        data: {
	            requiresLogin: true,
	            header: 'Statistics'
	        },
	        views: {
	            'breadcrumb@admin': {
	                template: '\n                    '
	            },
	            'main@admin': {
	                template: '<admin-statistics></admin-statistics>'
	            }
	        },
	        resolve: {
	            loadDashboardComponent: ["$q", "$ocLazyLoad", function loadDashboardComponent($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(26, function () {
	                    var name = __webpack_require__(1138).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }]
	        }
	
	    }).state('admin.projects', {
	
	        url: '/projects/:projectId',
	        data: {
	            requiresLogin: true,
	            header: 'Projects'
	        },
	
	        views: {
	            'breadcrumb@admin': {
	                template: '\n                    '
	            },
	            'main': {
	                template: '<project-list-container></project-list-container>'
	            }
	        },
	
	        resolve: {
	            // lazyLoad($q, $ocLazyLoad) {
	            //     'ngInject';
	
	            //     const deferred = $q.defer();
	
	            //     require.ensure([], function() {
	            //         const name = require('./components/admin/project/components/list/project.list.module.js').default.name;
	            //         $ocLazyLoad.load({ name }).then(function() {
	            //             deferred.resolve();
	            //         });
	            //     });
	            //     return deferred.promise;
	            // }
	            lazyLoad: ["$q", "$ocLazyLoad", function lazyLoad($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(27, function () {
	                    var name = __webpack_require__(1147).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	                return deferred.promise;
	            }]
	        }
	
	    }).state('admin.productAdmin', {
	        url: '/collections',
	        data: {
	            requiresLogin: true,
	            header: 'Product admin'
	        },
	        ncyBreadcrumb: {
	            label: 'New Uploads'
	        },
	        views: {
	            'breadcrumb@admin': {
	                template: '\n                        <div ncy-breadcrumb></div>\n                    '
	            },
	            'main@admin': {
	                template: '<product-admin></product-admin>'
	            }
	        },
	        resolve: {
	            loadDashboardComponent: ["$q", "$ocLazyLoad", function loadDashboardComponent($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(31, function () {
	                    var name = __webpack_require__(1208).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }]
	        }
	
	    }).state('admin.productAdmin.collection', {
	        url: '/{collectionId}/products',
	        data: {
	            requiresLogin: true
	        },
	        ncyBreadcrumb: {
	            label: 'Edit Information'
	        },
	        views: {
	            'main@admin': {
	                template: '<product-list></product-list>'
	            }
	        },
	        resolve: {
	            loadProductListComponent: ["$q", "$ocLazyLoad", function loadProductListComponent($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(33, function () {
	                    var name = __webpack_require__(1226).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }]
	        }
	
	    }).state('admin.productAdmin.collection.product', {
	        url: '/{productId}/edit',
	        data: {
	            requiresLogin: true
	        },
	        ncyBreadcrumb: {
	            label: '{{$resolve.product.product_information}}'
	        },
	        views: {
	            'main@admin': {
	                // component: 'editProduct'
	                template: '<edit-product product-id="::$resolve.productId"></edit-product>'
	            }
	        },
	        // controller: function($scope, productService, $stateParams) {
	        //     $scope.product = {};
	
	        //     productService.getProduct($stateParams.productId)
	        //         .then((response) => {
	        //             console.log(response);
	        //             return response;
	        //         })
	        //         .catch((response) => {
	        //             console.log(response);
	        //         });
	
	        // },
	        resolve: {
	            loadEditProductComponent: ["$q", "$ocLazyLoad", function loadEditProductComponent($q, $ocLazyLoad) {
	                'ngInject';
	
	                var deferred = $q.defer();
	
	                __webpack_require__.e/* nsure */(35, function () {
	                    var name = __webpack_require__(1250).default.name;
	                    $ocLazyLoad.load({ name: name }).then(function () {
	                        deferred.resolve();
	                    });
	                });
	
	                return deferred.promise;
	            }],
	
	
	            productId: ["$stateParams", function productId($stateParams) {
	                'ngInject';
	
	                return $stateParams.productId;
	            }],
	
	            product: ["$stateParams", "$http", function product($stateParams, $http) {
	                'ngInject';
	                // var deferred = this.$q.defer();
	
	                return $http({
	                    method: 'GET',
	                    url: _config2.default.API + '/product/' + $stateParams.productId
	                }).then(function (response) {
	                    // deferred.resolve(response.data);
	                    return response.data;
	                    ////console.log('Success ' + JSON.stringify(resp.config.data.file) + 'uploaded. Response: ' + resp.data);
	                });
	
	                // return deferred.promise;
	            }]
	
	        }
	
	    });
	
	    $urlRouterProvider.otherwise('/dashboard');
	
	    jwtOptionsProvider.config({
	        tokenGetter: function tokenGetter() {
	            return localStorage.getItem('id_token');
	        },
	        whiteListedDomains: ['localhost', 'cbapi.q-tests.com', 'cbapiproduction.q-tests.com', 'cbapiproduction.centerteam.com', 'centerteambackend.dev', 'content-bank-local-api.com'],
	        unauthenticatedRedirector: ['$state', function ($state) {
	            $state.go('root.login');
	        }]
	    });
	    $httpProvider.interceptors.push('jwtInterceptor');
	}]);
	
	_angular2.default.module('contentBank').service('Authentication', _authentication2.default).service('Collection', _collection2.default).service('Email', _email2.default).constant('Config', _config2.default).run(run);
	
	// run.$inject = [
	//     'authManager',
	//     '$rootScope',
	//     '$state'
	// ];
	
	function run(authManager, $rootScope, $state, Authentication) {
	    'ngInject';
	
	    authManager.checkAuthOnRefresh();
	    authManager.redirectWhenUnauthenticated();
	
	    $rootScope.localStorage = localStorage;
	    $rootScope.$state = $state;
	
	    $rootScope.$on('$stateChangeStart', function (event, toState) {
	        if (toState.name === 'root.login' && $rootScope.isAuthenticated) {
	            event.preventDefault();
	            $state.go('user.dashboard');
	            return;
	        }
	
	        if (toState.name === 'user.dashboard' && Authentication._getUser().is_content_bank_admin == "true") {
	            event.preventDefault();
	            $state.go('admin.dashboard', null, { reload: true });
	            return;
	        }
	
	        if (toState.name === 'admin.dashboard' && Authentication._getUser().is_uploader == "true") {
	            event.preventDefault();
	            $state.go('user.dashboard', null, { reload: true });
	            return;
	        }
	
	        if (Authentication._getUser().is_uploader == "false" && Authentication._getUser().is_content_bank_admin == "false") {
	            event.preventDefault();
	            Authentication.logOut();
	            return;
	        }
	    });
	}

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

	module.exports = "<div class=block-ui-overlay> </div> <div class=block-ui-message-container> <div class=block-ui-message> <div class=loader>Loading...</div> </div> </div> ";

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(322);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(323);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function () {
	    _class.$inject = ["$http", "authManager", "Config", "toastr"];
	    function _class($http, authManager, Config, toastr) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, _class);
	        this.$http = $http;
	        this.authManager = authManager;
	        this.Config = Config;
	        this.toastr = toastr;
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: 'logIn',
	        value: function logIn(email, password) {
	            var _this = this;
	
	            var url = this.Config.API + '/token/issue';
	
	            return this.$http({
	                method: 'POST',
	                url: url,
	                data: { email: email, password: password }
	            }).then(function (response) {
	
	                if (!response.data.user.is_content_bank_admin && !response.data.user.is_uploader) {
	                    _this.toastr.info("You are not allowed to access Content Bank at the moment, sorry.");
	                    return;
	                }
	
	                _this._setUser(response.data.user, response.data.center_token);
	                _this.authManager.authenticate();
	            });
	        }
	    }, {
	        key: 'logOut',
	        value: function logOut() {
	            this._clearUser();
	            this.authManager.unauthenticate();
	            this.authManager.redirect();
	        }
	    }, {
	        key: '_getUser',
	        value: function _getUser() {
	            var user = {};
	            user.id = localStorage.getItem('userId', user.id);
	            user.email = localStorage.getItem('userEmail', user.email);
	            user.role = localStorage.getItem('userRole', user.role);
	            user.name = localStorage.getItem('userName', user.userName);
	            user.surname = localStorage.getItem('userLastName', user.userLastName);
	            user.is_content_bank_admin = localStorage.getItem('userIsContentBankAdmin', user.is_content_bank_admin);
	            user.is_uploader = localStorage.getItem('userIsUploader', user.is_uploader);
	
	            return user;
	        }
	
	        /**
	         * @param {Object} user
	         * @param {string} token
	         */
	
	    }, {
	        key: '_setUser',
	        value: function _setUser(user, token) {
	            localStorage.setItem('userId', user.id);
	            localStorage.setItem('userEmail', user.email);
	            localStorage.setItem('userRole', user.role);
	            localStorage.setItem('userName', user.userName);
	            localStorage.setItem('userLastName', user.userLastName);
	            localStorage.setItem('id_token', token);
	            localStorage.setItem('userIsContentBankAdmin', user.is_content_bank_admin);
	            localStorage.setItem('userIsUploader', user.is_uploader);
	        }
	    }, {
	        key: '_clearUser',
	        value: function _clearUser() {
	            localStorage.removeItem('userId');
	            localStorage.removeItem('userEmail');
	            localStorage.removeItem('userRole');
	            localStorage.removeItem('userName');
	            localStorage.removeItem('userLastName');
	            localStorage.removeItem('userLang');
	            localStorage.removeItem('id_token');
	            localStorage.removeItem('userIsContentBankAdmin');
	            localStorage.removeItem('userIsUploader');
	        }
	    }, {
	        key: 'getUserInfo',
	        value: function getUserInfo(id) {
	            var url = this.Config.API + '/users/' + id;
	
	            return this.$http({
	                method: 'GET',
	                url: url
	            }).then(function (response) {
	                if (response.data.is_uploader) {
	                    localStorage.setItem("retailer_id", response.data.retailer.id);
	                    localStorage.setItem("retailer_name", response.data.retailer.name);
	                }
	            });
	        }
	    }]);
	    return _class;
	}();
	
	exports.default = _class;
	;

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(322);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(323);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by lapcho on 06.02.17..
	 */
	var _class = function () {
	    _class.$inject = ["$http", "toastr", "$q", "$state", "Config"];
	    function _class($http, toastr, $q, $state, Config) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, _class);
	        this.$http = $http;
	        this.toastr = toastr;
	        this.$q = $q;
	        this.Config = Config;
	        this.$state = $state;
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.products = null;
	            this.collection = null;
	        }
	    }, {
	        key: 'initProducts',
	        value: function initProducts(products) {
	            this.products = products;
	            this.$state.go("user.productCollection");
	        }
	    }, {
	        key: 'getCollection',
	        value: function getCollection(id) {
	            var _this = this;
	
	            this.dropDownSelected = true;
	
	            return this.$http({
	                url: this.Config.API + '/contentbank-collection/' + id,
	                method: 'GET'
	
	            }).then(function (response) {
	
	                //need to add push products from service to array
	                _this.collection = response.data;
	            }).catch(function (status) {
	
	                _this.toastr.error('Server Error, Try again');
	            });
	        }
	    }, {
	        key: 'getExistingCollections',
	        value: function getExistingCollections(drafts) {
	            var _this2 = this;
	
	            return this.$http({
	                url: this.Config.API + '/contentbank-collection/',
	                method: 'GET',
	                headers: {
	                    'drafts': drafts
	                }
	
	            }).then(function (response) {
	
	                _this2.existingCollections = response.data;
	            }).catch(function (status) {
	
	                _this2.toastr.error('Server Error, Try again');
	            });
	        }
	    }, {
	        key: 'generatePdfDownloadLinkForCollections',
	        value: function generatePdfDownloadLinkForCollections(collections) {
	            var queryString = '?';
	            angular.forEach(collections, function (value, key) {
	                var tmp = 'collection[]=' + value;
	                if (collections.length - 1 != key) {
	                    tmp += '&';
	                }
	                queryString += tmp;
	            });
	            return this.Config.API + '/contentbank-collection/pdf/download' + queryString;
	        }
	    }, {
	        key: 'deleteCollections',
	        value: function deleteCollections(id_array) {
	            var _this3 = this;
	
	            console.log('col service delete');
	            var promises = [];
	            angular.forEach(id_array, function (id) {
	                promises.push(_this3.$http({
	                    url: _this3.Config.API + '/contentbank-collection/' + id,
	                    method: 'DELETE'
	                }).then(function (response) {}).catch(function (status) {
	                    _this3.toastr.error('Server Error while deleting collection, Try again');
	                }));
	            });
	            return this.$q.all(promises);
	        }
	    }, {
	        key: 'updateReadAt',
	        value: function updateReadAt(collectionId) {
	            var _this4 = this;
	
	            var deferred = this.$q.defer();
	
	            this.getCollection(collectionId).then(function () {
	                var data = {
	                    "read_at": Math.round(new Date().getTime() / 1000)
	                };
	                _this4.$http({
	                    url: _this4.Config.API + '/contentbank-collection/' + _this4.collection.id,
	                    method: 'PATCH',
	                    data: data
	                }).then(function (response) {
	                    deferred.resolve(response.data);
	                    //collection updated
	                });
	            });
	
	            return deferred.promise;
	        }
	    }, {
	        key: 'markUnread',
	        value: function markUnread(id_array) {
	            var _this5 = this;
	
	            var promises = [];
	            angular.forEach(id_array, function (id) {
	
	                promises.push(_this5.getCollection(id).then(function () {
	                    // console.log(this.collection);
	                    var data = {
	                        "read_at": 0
	                    };
	                    return _this5.$http({
	                        url: _this5.Config.API + '/contentbank-collection/' + _this5.collection.id,
	                        method: 'PATCH',
	                        data: data
	                    });
	                }));
	            });
	            return this.$q.all(promises);
	        }
	    }, {
	        key: 'markAsMine',
	        value: function markAsMine(id_array) {
	            var _this6 = this;
	
	            var promises = [];
	            angular.forEach(id_array, function (id) {
	                promises.push(_this6.getCollection(id).then(function () {
	                    var data = {
	                        "owner_id": localStorage.getItem('userId')
	                    };
	                    _this6.$http({
	                        url: _this6.Config.API + '/contentbank-collection/' + _this6.collection.id,
	                        method: 'PATCH',
	                        data: data
	                    }).then(function (response) {
	                        //collection updated
	                    });
	                }));
	            });
	            return this.$q.all(promises);
	        }
	    }, {
	        key: 'archive',
	        value: function archive(id) {
	            var deferred = this.$q.defer();
	
	            this.$http({
	                url: this.Config.API + '/contentbank-collection/' + this.collection.id,
	                method: 'PATCH',
	                data: {
	                    archived: true,
	                    owner_id: null
	                }
	            }).then(function (response) {
	                deferred.resolve(response.data);
	                //collection updated
	            });
	
	            return deferred.promise;
	        }
	    }, {
	        key: 'updateStarred',
	        value: function updateStarred(collectionId, starred) {
	            var _this7 = this;
	
	            var deferred = this.$q.defer();
	
	            this.getCollection(collectionId).then(function () {
	                var data = {
	                    'starred': starred
	                };
	                _this7.$http({
	                    url: _this7.Config.API + '/contentbank-collection/' + collectionId,
	                    method: 'PATCH',
	                    data: data
	                }).then(function (response) {
	                    deferred.resolve(response.data);
	                    //collection updated
	                });
	            });
	
	            return deferred.promise;
	        }
	    }]);
	    return _class;
	}();
	
	exports.default = _class;

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(322);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(323);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by lapcho on 24.02.17..
	 */
	/**
	 * Created by lapcho on 06.02.17..
	 */
	var _class = function () {
	    _class.$inject = ["$http", "toastr", "$q", "Config"];
	    function _class($http, toastr, $q, Config) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, _class);
	        this.$http = $http;
	        this.toastr = toastr;
	        this.$q = $q;
	        this.Config = Config;
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'sendEmailWithCollections',
	        value: function sendEmailWithCollections(address, collection_ids) {
	            var _this = this;
	
	            var data = {
	                collections: collection_ids,
	                email: address
	            };
	            return this.$http({
	                url: this.Config.API + '/contentbank-collection/pdf/email',
	                method: 'POST',
	                data: data
	            }).then(function (response) {
	                _this.toastr.success('Collections PDF sent to email');
	            }).catch(function (status) {
	                _this.toastr.error('Error occured while sending email, please try again');
	            });
	        }
	    }]);
	    return _class;
	}();
	
	exports.default = _class;

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	
	    API: 'https://cbapiproduction.centerteam.com/api'
	
	};

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

	/*!
	 * ui-select
	 * http://github.com/angular-ui/ui-select
	 * Version: 0.19.8 - 2017-04-18T05:43:43.673Z
	 * License: MIT
	 */
	
	
	(function() {
	    "use strict";
	    var KEY = {
	        TAB: 9,
	        ENTER: 13,
	        ESC: 27,
	        SPACE: 32,
	        LEFT: 37,
	        UP: 38,
	        RIGHT: 39,
	        DOWN: 40,
	        SHIFT: 16,
	        CTRL: 17,
	        ALT: 18,
	        PAGE_UP: 33,
	        PAGE_DOWN: 34,
	        HOME: 36,
	        END: 35,
	        BACKSPACE: 8,
	        DELETE: 46,
	        COMMAND: 91,
	
	        MAP: {
	            91: "COMMAND",
	            8: "BACKSPACE",
	            9: "TAB",
	            13: "ENTER",
	            16: "SHIFT",
	            17: "CTRL",
	            18: "ALT",
	            19: "PAUSEBREAK",
	            20: "CAPSLOCK",
	            27: "ESC",
	            32: "SPACE",
	            33: "PAGE_UP",
	            34: "PAGE_DOWN",
	            35: "END",
	            36: "HOME",
	            37: "LEFT",
	            38: "UP",
	            39: "RIGHT",
	            40: "DOWN",
	            43: "+",
	            44: "PRINTSCREEN",
	            45: "INSERT",
	            46: "DELETE",
	            48: "0",
	            49: "1",
	            50: "2",
	            51: "3",
	            52: "4",
	            53: "5",
	            54: "6",
	            55: "7",
	            56: "8",
	            57: "9",
	            59: ";",
	            61: "=",
	            65: "A",
	            66: "B",
	            67: "C",
	            68: "D",
	            69: "E",
	            70: "F",
	            71: "G",
	            72: "H",
	            73: "I",
	            74: "J",
	            75: "K",
	            76: "L",
	            77: "M",
	            78: "N",
	            79: "O",
	            80: "P",
	            81: "Q",
	            82: "R",
	            83: "S",
	            84: "T",
	            85: "U",
	            86: "V",
	            87: "W",
	            88: "X",
	            89: "Y",
	            90: "Z",
	            96: "0",
	            97: "1",
	            98: "2",
	            99: "3",
	            100: "4",
	            101: "5",
	            102: "6",
	            103: "7",
	            104: "8",
	            105: "9",
	            106: "*",
	            107: "+",
	            109: "-",
	            110: ".",
	            111: "/",
	            112: "F1",
	            113: "F2",
	            114: "F3",
	            115: "F4",
	            116: "F5",
	            117: "F6",
	            118: "F7",
	            119: "F8",
	            120: "F9",
	            121: "F10",
	            122: "F11",
	            123: "F12",
	            144: "NUMLOCK",
	            145: "SCROLLLOCK",
	            186: ";",
	            187: "=",
	            188: ",",
	            189: "-",
	            190: ".",
	            191: "/",
	            192: "`",
	            219: "[",
	            220: "\\",
	            221: "]",
	            222: "'"
	        },
	
	        isControl: function(e) {
	            var k = e.which;
	            switch (k) {
	                case KEY.COMMAND:
	                case KEY.SHIFT:
	                case KEY.CTRL:
	                case KEY.ALT:
	                    return true;
	            }
	
	            if (e.metaKey || e.ctrlKey || e.altKey) return true;
	
	            return false;
	        },
	        isFunctionKey: function(k) {
	            k = k.which ? k.which : k;
	            return k >= 112 && k <= 123;
	        },
	        isVerticalMovement: function(k) {
	            return ~[KEY.UP, KEY.DOWN].indexOf(k);
	        },
	        isHorizontalMovement: function(k) {
	            return ~[KEY.LEFT, KEY.RIGHT, KEY.BACKSPACE, KEY.DELETE].indexOf(k);
	        },
	        toSeparator: function(k) {
	            var sep = { ENTER: "\n", TAB: "\t", SPACE: " " }[k];
	            if (sep) return sep;
	            // return undefined for special keys other than enter, tab or space.
	            // no way to use them to cut strings.
	            return KEY[k] ? undefined : k;
	        }
	    };
	
	    function isNil(value) {
	        return angular.isUndefined(value) || value === null;
	    }
	
	    /**
	     * Add querySelectorAll() to jqLite.
	     *
	     * jqLite find() is limited to lookups by tag name.
	     * TODO This will change with future versions of AngularJS, to be removed when this happens
	     *
	     * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
	     * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
	     */
	    if (angular.element.prototype.querySelectorAll === undefined) {
	        angular.element.prototype.querySelectorAll = function(selector) {
	            return angular.element(this[0].querySelectorAll(selector));
	        };
	    }
	
	    /**
	     * Add closest() to jqLite.
	     */
	    if (angular.element.prototype.closest === undefined) {
	        angular.element.prototype.closest = function(selector) {
	            var elem = this[0];
	            var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	
	            while (elem) {
	                if (matchesSelector.bind(elem)(selector)) {
	                    return elem;
	                } else {
	                    elem = elem.parentElement;
	                }
	            }
	            return false;
	        };
	    }
	
	    var latestId = 0;
	
	    var uis = angular.module('ui.select', [])
	
	    .constant('uiSelectConfig', {
	        theme: 'bootstrap',
	        searchEnabled: true,
	        allowFreeText: false,
	        sortable: false,
	        placeholder: '', // Empty by default, like HTML tag <select>
	        refreshDelay: 1000, // In milliseconds
	        closeOnSelect: true,
	        skipFocusser: false,
	        dropdownPosition: 'auto',
	        removeSelected: true,
	        resetSearchInput: true,
	        generateId: function() {
	            return latestId++;
	        },
	        appendToBody: false,
	        spinnerEnabled: false,
	        spinnerClass: 'glyphicon glyphicon-refresh ui-select-spin',
	        backspaceReset: true
	    })
	
	    // See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
	    .service('uiSelectMinErr', function() {
	        var minErr = angular.$$minErr('ui.select');
	        return function() {
	            var error = minErr.apply(this, arguments);
	            var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
	            return new Error(message);
	        };
	    })
	
	    // Recreates old behavior of ng-transclude. Used internally.
	    .directive('uisTranscludeAppend', function() {
	        return {
	            link: function(scope, element, attrs, ctrl, transclude) {
	                transclude(scope, function(clone) {
	                    element.append(clone);
	                });
	            }
	        };
	    })
	
	    /**
	     * Highlights text that matches $select.search.
	     *
	     * Taken from AngularUI Bootstrap Typeahead
	     * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
	     */
	    .filter('highlight', function() {
	        function escapeRegexp(queryToEscape) {
	            return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	        }
	
	        return function(matchItem, query) {
	            return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
	        };
	    })
	
	    /**
	     * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
	     *
	     * Taken from AngularUI Bootstrap Position:
	     * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
	     */
	    .factory('uisOffset', ['$document', '$window',
	        function($document, $window) {
	
	            return function(element) {
	                var boundingClientRect = element[0].getBoundingClientRect();
	                return {
	                    width: boundingClientRect.width || element.prop('offsetWidth'),
	                    height: boundingClientRect.height || element.prop('offsetHeight'),
	                    top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	                    left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	                };
	            };
	        }
	    ]);
	
	    uis.directive('uiSelectChoices', ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window',
	        function(uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
	
	            return {
	                restrict: 'EA',
	                require: '^uiSelect',
	                replace: true,
	                transclude: true,
	                templateUrl: function(tElement) {
	                    // Needed so the uiSelect can detect the transcluded content
	                    tElement.addClass('ui-select-choices');
	
	                    // Gets theme attribute from parent (ui-select)
	                    var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	                    return theme + '/choices.tpl.html';
	                },
	
	                compile: function(tElement, tAttrs) {
	
	                    if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");
	
	                    // var repeat = RepeatParser.parse(attrs.repeat);
	                    var groupByExp = tAttrs.groupBy;
	                    var groupFilterExp = tAttrs.groupFilter;
	
	                    if (groupByExp) {
	                        var groups = tElement.querySelectorAll('.ui-select-choices-group');
	                        if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
	                        groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
	                    }
	
	                    var parserResult = RepeatParser.parse(tAttrs.repeat);
	
	                    var choices = tElement.querySelectorAll('.ui-select-choices-row');
	                    if (choices.length !== 1) {
	                        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
	                    }
	
	                    choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp))
	                        .attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed
	
	
	                    var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
	                    if (rowsInner.length !== 1) {
	                        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
	                    }
	                    rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat
	
	                    // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event.
	                    var clickTarget = $window.document.addEventListener ? choices : rowsInner;
	                    clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
	
	                    return function link(scope, element, attrs, $select) {
	
	
	                        $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
	                        $select.disableChoiceExpression = attrs.uiDisableChoice;
	                        $select.onHighlightCallback = attrs.onHighlight;
	                        $select.minimumInputLength = parseInt(attrs.minimumInputLength) || 0;
	                        $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;
	
	                        scope.$watch('$select.search', function(newValue) {
	                            if (newValue && !$select.open && $select.multiple) $select.activate(false, true);
	                            $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
	                            if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
	                                $select.refresh(attrs.refresh);
	                            } else {
	                                $select.items = [];
	                            }
	                        });
	
	                        attrs.$observe('refreshDelay', function() {
	                            // $eval() is needed otherwise we get a string instead of a number
	                            var refreshDelay = scope.$eval(attrs.refreshDelay);
	                            $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
	                        });
	
	                        scope.$watch('$select.open', function(open) {
	                            if (open) {
	                                tElement.attr('role', 'listbox');
	                                $select.refresh(attrs.refresh);
	                            } else {
	                                element.removeAttr('role');
	                            }
	                        });
	                    };
	                }
	            };
	        }
	    ]);
	
	    /**
	     * Contains ui-select "intelligence".
	     *
	     * The goal is to limit dependency on the DOM whenever possible and
	     * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
	     */
	    uis.controller('uiSelectCtrl', ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window',
	        function($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
	
	            var ctrl = this;
	
	            var EMPTY_SEARCH = '';
	
	            ctrl.placeholder = uiSelectConfig.placeholder;
	            ctrl.searchEnabled = uiSelectConfig.searchEnabled;
	            ctrl.sortable = uiSelectConfig.sortable;
	            ctrl.allowFreeText = uiSelectConfig.allowFreeText;
	            ctrl.refreshDelay = uiSelectConfig.refreshDelay;
	            ctrl.paste = uiSelectConfig.paste;
	            ctrl.resetSearchInput = uiSelectConfig.resetSearchInput;
	            ctrl.refreshing = false;
	            ctrl.spinnerEnabled = uiSelectConfig.spinnerEnabled;
	            ctrl.spinnerClass = uiSelectConfig.spinnerClass;
	            ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
	            ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
	            ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
	            ctrl.search = EMPTY_SEARCH;
	
	            ctrl.activeIndex = 0; //Dropdown of choices
	            ctrl.items = []; //All available choices
	
	            ctrl.open = false;
	            ctrl.focus = false;
	            ctrl.disabled = false;
	            ctrl.selected = undefined;
	
	            ctrl.dropdownPosition = 'auto';
	
	            ctrl.focusser = undefined; //Reference to input element used to handle focus events
	            ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
	            ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
	            ctrl.tagging = { isActivated: false, fct: undefined };
	            ctrl.taggingTokens = { isActivated: false, tokens: undefined };
	            ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
	            ctrl.clickTriggeredSelect = false;
	            ctrl.$filter = $filter;
	            ctrl.$element = $element;
	
	            // Use $injector to check for $animate and store a reference to it
	            ctrl.$animate = (function() {
	                try {
	                    return $injector.get('$animate');
	                } catch (err) {
	                    // $animate does not exist
	                    return null;
	                }
	            })();
	
	            ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
	            if (ctrl.searchInput.length !== 1) {
	                throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
	            }
	
	            ctrl.isEmpty = function() {
	                return isNil(ctrl.selected) || ctrl.selected === '' || (ctrl.multiple && ctrl.selected.length === 0);
	            };
	
	            function _findIndex(collection, predicate, thisArg) {
	                if (collection.findIndex) {
	                    return collection.findIndex(predicate, thisArg);
	                } else {
	                    var list = Object(collection);
	                    var length = list.length >>> 0;
	                    var value;
	
	                    for (var i = 0; i < length; i++) {
	                        value = list[i];
	                        if (predicate.call(thisArg, value, i, list)) {
	                            return i;
	                        }
	                    }
	                    return -1;
	                }
	            }
	
	            // Most of the time the user does not want to empty the search input when in typeahead mode
	            function _resetSearchInput() {
	                if (ctrl.resetSearchInput) {
	                    ctrl.search = EMPTY_SEARCH;
	                    //reset activeIndex
	                    if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
	                        ctrl.activeIndex = _findIndex(ctrl.items, function(item) {
	                            return angular.equals(this, item);
	                        }, ctrl.selected);
	                    }
	                }
	            }
	
	            function _groupsFilter(groups, groupNames) {
	                var i, j, result = [];
	                for (i = 0; i < groupNames.length; i++) {
	                    for (j = 0; j < groups.length; j++) {
	                        if (groups[j].name == [groupNames[i]]) {
	                            result.push(groups[j]);
	                        }
	                    }
	                }
	                return result;
	            }
	
	            // When the user clicks on ui-select, displays the dropdown list
	            ctrl.activate = function(initSearchValue, avoidReset) {
	                if (!ctrl.disabled && !ctrl.open) {
	                    if (!avoidReset) _resetSearchInput();
	
	                    $scope.$broadcast('uis:activate');
	                    ctrl.open = true;
	                    ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
	                    // ensure that the index is set to zero for tagging variants
	                    // that where first option is auto-selected
	                    if (ctrl.activeIndex === -1 && ctrl.taggingLabel !== false) {
	                        ctrl.activeIndex = 0;
	                    }
	
	                    var container = $element.querySelectorAll('.ui-select-choices-content');
	                    var searchInput = $element.querySelectorAll('.ui-select-search');
	                    if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
	                        var animateHandler = function(elem, phase) {
	                            if (phase === 'start' && ctrl.items.length === 0) {
	                                // Only focus input after the animation has finished
	                                ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
	                                $timeout(function() {
	                                    ctrl.focusSearchInput(initSearchValue);
	                                });
	                            } else if (phase === 'close') {
	                                // Only focus input after the animation has finished
	                                ctrl.$animate.off('enter', container[0], animateHandler);
	                                $timeout(function() {
	                                    ctrl.focusSearchInput(initSearchValue);
	                                });
	                            }
	                        };
	
	                        if (ctrl.items.length > 0) {
	                            ctrl.$animate.on('enter', container[0], animateHandler);
	                        } else {
	                            ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
	                        }
	                    } else {
	                        $timeout(function() {
	                            ctrl.focusSearchInput(initSearchValue);
	                            if (!ctrl.tagging.isActivated && ctrl.items.length > 1) {
	                                _ensureHighlightVisible();
	                            }
	                        });
	                    }
	                } else if (ctrl.open && !ctrl.searchEnabled) {
	                    // Close the selection if we don't have search enabled, and we click on the select again
	                    ctrl.close();
	                }
	            };
	
	            ctrl.focusSearchInput = function(initSearchValue) {
	                ctrl.search = initSearchValue || ctrl.search;
	                ctrl.searchInput[0].focus();
	            };
	
	            ctrl.findGroupByName = function(name) {
	                return ctrl.groups && ctrl.groups.filter(function(group) {
	                    return group.name === name;
	                })[0];
	            };
	
	            ctrl.parseRepeatAttr = function(repeatAttr, groupByExp, groupFilterExp) {
	                function updateGroups(items) {
	                    var groupFn = $scope.$eval(groupByExp);
	                    ctrl.groups = [];
	                    angular.forEach(items, function(item) {
	                        var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
	                        var group = ctrl.findGroupByName(groupName);
	                        if (group) {
	                            group.items.push(item);
	                        } else {
	                            ctrl.groups.push({ name: groupName, items: [item] });
	                        }
	                    });
	                    if (groupFilterExp) {
	                        var groupFilterFn = $scope.$eval(groupFilterExp);
	                        if (angular.isFunction(groupFilterFn)) {
	                            ctrl.groups = groupFilterFn(ctrl.groups);
	                        } else if (angular.isArray(groupFilterFn)) {
	                            ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
	                        }
	                    }
	                    ctrl.items = [];
	                    ctrl.groups.forEach(function(group) {
	                        ctrl.items = ctrl.items.concat(group.items);
	                    });
	                }
	
	                function setPlainItems(items) {
	                    ctrl.items = items || [];
	                }
	
	                ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
	
	                ctrl.parserResult = RepeatParser.parse(repeatAttr);
	
	                ctrl.isGrouped = !!groupByExp;
	                ctrl.itemProperty = ctrl.parserResult.itemName;
	
	                //If collection is an Object, convert it to Array
	
	                var originalSource = ctrl.parserResult.source;
	
	                //When an object is used as source, we better create an array and use it as 'source'
	                var createArrayFromObject = function() {
	                    var origSrc = originalSource($scope);
	                    $scope.$uisSource = Object.keys(origSrc).map(function(v) {
	                        var result = {};
	                        result[ctrl.parserResult.keyName] = v;
	                        result.value = origSrc[v];
	                        return result;
	                    });
	                };
	
	                if (ctrl.parserResult.keyName) { // Check for (key,value) syntax
	                    createArrayFromObject();
	                    ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
	                    $scope.$watch(originalSource, function(newVal, oldVal) {
	                        if (newVal !== oldVal) createArrayFromObject();
	                    }, true);
	                }
	
	                ctrl.refreshItems = function(data) {
	                    data = data || ctrl.parserResult.source($scope);
	                    var selectedItems = ctrl.selected;
	                    //TODO should implement for single mode removeSelected
	                    if (ctrl.isEmpty() || (angular.isArray(selectedItems) && !selectedItems.length) || !ctrl.multiple || !ctrl.removeSelected) {
	                        ctrl.setItemsFn(data);
	                    } else {
	                        if (data !== undefined && data !== null) {
	                            var filteredItems = data.filter(function(i) {
	                                return angular.isArray(selectedItems) ? selectedItems.every(function(selectedItem) {
	                                    return !angular.equals(i, selectedItem);
	                                }) : !angular.equals(i, selectedItems);
	                            });
	                            ctrl.setItemsFn(filteredItems);
	                        }
	                    }
	                    if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up') {
	                        $scope.calculateDropdownPos();
	                    }
	                    $scope.$broadcast('uis:refresh');
	                };
	
	                // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
	                $scope.$watchCollection(ctrl.parserResult.source, function(items) {
	                    if (items === undefined || items === null) {
	                        // If the user specifies undefined or null => reset the collection
	                        // Special case: items can be undefined if the user did not initialized the collection on the scope
	                        // i.e $scope.addresses = [] is missing
	                        ctrl.items = [];
	                    } else {
	                        if (!angular.isArray(items)) {
	                            throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
	                        } else {
	                            //Remove already selected items (ex: while searching)
	                            //TODO Should add a test
	                            ctrl.refreshItems(items);
	
	                            //update the view value with fresh data from items, if there is a valid model value
	                            if (angular.isDefined(ctrl.ngModel.$modelValue)) {
	                                ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	                            }
	                        }
	                    }
	                });
	
	            };
	
	            var _refreshDelayPromise;
	
	            /**
	             * Typeahead mode: lets the user refresh the collection using his own function.
	             *
	             * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
	             */
	            ctrl.refresh = function(refreshAttr) {
	                if (refreshAttr !== undefined) {
	                    // Debounce
	                    // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
	                    // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
	                    if (_refreshDelayPromise) {
	                        $timeout.cancel(_refreshDelayPromise);
	                    }
	                    _refreshDelayPromise = $timeout(function() {
	                        if ($scope.$select.search.length >= $scope.$select.minimumInputLength) {
	                            var refreshPromise = $scope.$eval(refreshAttr);
	                            if (refreshPromise && angular.isFunction(refreshPromise.then) && !ctrl.refreshing) {
	                                ctrl.refreshing = true;
	                                refreshPromise.finally(function() {
	                                    ctrl.refreshing = false;
	                                });
	                            }
	                        }
	                    }, ctrl.refreshDelay);
	                }
	            };
	
	            ctrl.isActive = function(itemScope) {
	                if (!ctrl.open) {
	                    return false;
	                }
	                var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
	                var isActive = itemIndex == ctrl.activeIndex;
	
	                if (!isActive || itemIndex < 0) {
	                    return false;
	                }
	
	                if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
	                    itemScope.$eval(ctrl.onHighlightCallback);
	                }
	
	                return isActive;
	            };
	
	            var _isItemSelected = function(item) {
	                return (ctrl.selected && angular.isArray(ctrl.selected) &&
	                    ctrl.selected.filter(function(selection) { return angular.equals(selection, item); }).length > 0);
	            };
	
	            var disabledItems = [];
	
	            function _updateItemDisabled(item, isDisabled) {
	                var disabledItemIndex = disabledItems.indexOf(item);
	                if (isDisabled && disabledItemIndex === -1) {
	                    disabledItems.push(item);
	                }
	
	                if (!isDisabled && disabledItemIndex > -1) {
	                    disabledItems.splice(disabledItemIndex, 1);
	                }
	            }
	
	            function _isItemDisabled(item) {
	                return disabledItems.indexOf(item) > -1;
	            }
	
	            ctrl.isDisabled = function(itemScope) {
	
	                if (!ctrl.open) return;
	
	                var item = itemScope[ctrl.itemProperty];
	                var itemIndex = ctrl.items.indexOf(item);
	                var isDisabled = false;
	
	                if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {
	
	                    if (item.isTag) return false;
	
	                    if (ctrl.multiple) {
	                        isDisabled = _isItemSelected(item);
	                    }
	
	                    if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
	                        isDisabled = !!(itemScope.$eval(ctrl.disableChoiceExpression));
	                    }
	
	                    _updateItemDisabled(item, isDisabled);
	                }
	
	                return isDisabled;
	            };
	
	
	            // When the user selects an item with ENTER or clicks the dropdown
	            ctrl.select = function(item, skipFocusser, $event) {
	                if (isNil(item) || !_isItemDisabled(item)) {
	
	                    if (!ctrl.items && !ctrl.search && !ctrl.tagging.isActivated) return;
	
	                    if (!item || !_isItemDisabled(item)) {
	                        // if click is made on existing item, prevent from tagging, ctrl.search does not matter
	                        ctrl.clickTriggeredSelect = false;
	                        if ($event && ($event.type === 'click' || $event.type === 'touchend') && item)
	                            ctrl.clickTriggeredSelect = true;
	
	                        if (ctrl.tagging.isActivated && ctrl.clickTriggeredSelect === false) {
	                            // if taggingLabel is disabled and item is undefined we pull from ctrl.search
	                            if (ctrl.taggingLabel === false) {
	                                if (ctrl.activeIndex < 0) {
	                                    if (item === undefined) {
	                                        item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
	                                    }
	                                    if (!item || angular.equals(ctrl.items[0], item)) {
	                                        return;
	                                    }
	                                } else {
	                                    // keyboard nav happened first, user selected from dropdown
	                                    item = ctrl.items[ctrl.activeIndex];
	                                }
	                            } else {
	                                // tagging always operates at index zero, taggingLabel === false pushes
	                                // the ctrl.search value without having it injected
	                                if (ctrl.activeIndex === 0) {
	                                    // ctrl.tagging pushes items to ctrl.items, so we only have empty val
	                                    // for `item` if it is a detected duplicate
	                                    if (item === undefined) return;
	
	                                    // create new item on the fly if we don't already have one;
	                                    // use tagging function if we have one
	                                    if (ctrl.tagging.fct !== undefined && typeof item === 'string') {
	                                        item = ctrl.tagging.fct(item);
	                                        if (!item) return;
	                                        // if item type is 'string', apply the tagging label
	                                    } else if (typeof item === 'string') {
	                                        // trim the trailing space
	                                        item = item.replace(ctrl.taggingLabel, '').trim();
	                                    }
	                                }
	                            }
	                            // search ctrl.selected for dupes potentially caused by tagging and return early if found
	                            if (_isItemSelected(item)) {
	                                ctrl.close(skipFocusser);
	                                return;
	                            }
	                        }
	                        _resetSearchInput();
	                        $scope.$broadcast('uis:select', item);
	
	                        if (ctrl.closeOnSelect) {
	                            ctrl.close(skipFocusser);
	                        }
	                    }
	                }
	            };
	
	            // Closes the dropdown
	            ctrl.close = function(skipFocusser) {
	                if (!ctrl.open) return;
	                if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
	                ctrl.open = false;
	                _resetSearchInput();
	                $scope.$broadcast('uis:close', skipFocusser);
	
	            };
	
	            ctrl.setFocus = function() {
	                if (!ctrl.focus) ctrl.focusInput[0].focus();
	            };
	
	            ctrl.clear = function($event) {
	                ctrl.select(null);
	                $event.stopPropagation();
	                $timeout(function() {
	                    ctrl.focusser[0].focus();
	                }, 0, false);
	            };
	
	            // Toggle dropdown
	            ctrl.toggle = function(e) {
	                if (ctrl.open) {
	                    ctrl.close();
	                    e.preventDefault();
	                    e.stopPropagation();
	                } else {
	                    ctrl.activate();
	                }
	            };
	
	            // Set default function for locked choices - avoids unnecessary
	            // logic if functionality is not being used
	            ctrl.isLocked = function() {
	                return false;
	            };
	
	            $scope.$watch(function() {
	                return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
	            }, _initaliseLockedChoices);
	
	            function _initaliseLockedChoices(doInitalise) {
	                if (!doInitalise) return;
	
	                var lockedItems = [];
	
	                function _updateItemLocked(item, isLocked) {
	                    var lockedItemIndex = lockedItems.indexOf(item);
	                    if (isLocked && lockedItemIndex === -1) {
	                        lockedItems.push(item);
	                    }
	
	                    if (!isLocked && lockedItemIndex > -1) {
	                        lockedItems.splice(lockedItemIndex, 1);
	                    }
	                }
	
	                function _isItemlocked(item) {
	                    return lockedItems.indexOf(item) > -1;
	                }
	
	                ctrl.isLocked = function(itemScope, itemIndex) {
	                    var isLocked = false,
	                        item = ctrl.selected[itemIndex];
	
	                    if (item) {
	                        if (itemScope) {
	                            isLocked = !!(itemScope.$eval(ctrl.lockChoiceExpression));
	                            _updateItemLocked(item, isLocked);
	                        } else {
	                            isLocked = _isItemlocked(item);
	                        }
	                    }
	
	                    return isLocked;
	                };
	            }
	
	
	            var sizeWatch = null;
	            var updaterScheduled = false;
	            ctrl.sizeSearchInput = function() {
	
	                var input = ctrl.searchInput[0],
	                    container = ctrl.$element[0],
	                    calculateContainerWidth = function() {
	                        // Return the container width only if the search input is visible
	                        return container.clientWidth * !!input.offsetParent;
	                    },
	                    updateIfVisible = function(containerWidth) {
	                        if (containerWidth === 0) {
	                            return false;
	                        }
	                        var inputWidth = containerWidth - input.offsetLeft;
	                        if (inputWidth < 50) inputWidth = containerWidth;
	                        ctrl.searchInput.css('width', inputWidth + 'px');
	                        return true;
	                    };
	
	                ctrl.searchInput.css('width', '10px');
	                $timeout(function() { //Give tags time to render correctly
	                    if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
	                        sizeWatch = $scope.$watch(function() {
	                            if (!updaterScheduled) {
	                                updaterScheduled = true;
	                                $scope.$$postDigest(function() {
	                                    updaterScheduled = false;
	                                    if (updateIfVisible(calculateContainerWidth())) {
	                                        sizeWatch();
	                                        sizeWatch = null;
	                                    }
	                                });
	                            }
	                        }, angular.noop);
	                    }
	                });
	            };
	
	            function _handleDropDownSelection(key) {
	                var processed = true;
	                switch (key) {
	                    case KEY.DOWN:
	                        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	                        else if (ctrl.activeIndex < ctrl.items.length - 1) {
	                            var idx = ++ctrl.activeIndex;
	                            while (_isItemDisabled(ctrl.items[idx]) && idx < ctrl.items.length) {
	                                ctrl.activeIndex = ++idx;
	                            }
	                        }
	                        break;
	                    case KEY.UP:
	                        var minActiveIndex = (ctrl.search.length === 0 && ctrl.tagging.isActivated) ? -1 : 0;
	                        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	                        else if (ctrl.activeIndex > minActiveIndex) {
	                            var idxmin = --ctrl.activeIndex;
	                            while (_isItemDisabled(ctrl.items[idxmin]) && idxmin > minActiveIndex) {
	                                ctrl.activeIndex = --idxmin;
	                            }
	                        }
	                        break;
	                    case KEY.TAB:
	                        if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
	                        break;
	                    case KEY.ENTER:
	                        if (ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)) {
	                            ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
	                        } else {
	                            ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	                        }
	                        break;
	                    case KEY.ESC:
	                        ctrl.close();
	                        break;
	                    default:
	                        processed = false;
	                }
	                return processed;
	            }
	
	            function _handleBlurAndTab() {
	                if (ctrl.allowFreeText && ctrl.search) { // Make sure that the search is not empty, otherwise the blur event will override the tab keydown event
	                    ctrl.select(ctrl.search);
	                    ctrl.close();
	                    ctrl.search = EMPTY_SEARCH;
	                }
	            }
	
	            ctrl.searchInput.on('blur', function() {
	                _handleBlurAndTab();
	            });
	
	            // Bind to keyboard shortcuts
	            ctrl.searchInput.on('keydown', function(e) {
	
	                var key = e.which;
	
	                if (~[KEY.ENTER, KEY.ESC].indexOf(key)) {
	                    e.preventDefault();
	                    e.stopPropagation();
	                }
	
	                $scope.$apply(function() {
	
	                    var tagged = false;
	
	                    if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
	                        if (!_handleDropDownSelection(key) && !ctrl.searchEnabled) {
	                            e.preventDefault();
	                            e.stopPropagation();
	                        }
	                        if (ctrl.taggingTokens.isActivated) {
	                            for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	                                if (ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode]) {
	                                    // make sure there is a new value to push via tagging
	                                    if (ctrl.search.length > 0) {
	                                        tagged = true;
	                                    }
	                                }
	                            }
	                            if (tagged) {
	                                $timeout(function() {
	                                    ctrl.searchInput.triggerHandler('tagged');
	                                    var newItem = ctrl.search.replace(KEY.MAP[e.keyCode], '').trim();
	                                    if (ctrl.tagging.fct) {
	                                        newItem = ctrl.tagging.fct(newItem);
	                                    }
	                                    if (newItem) ctrl.select(newItem, true);
	                                });
	                            }
	                        }
	                    } else if (~[KEY.ESC, KEY.TAB].indexOf(key)) {
	                        if (!ctrl.allowFreeText) {
	                            ctrl.close();
	                        } else {
	                            _handleBlurAndTab();
	                        }
	                    }
	
	                });
	
	                if (KEY.isVerticalMovement(key) && ctrl.items.length > 0) {
	                    _ensureHighlightVisible();
	                }
	
	                if (key === KEY.ENTER || key === KEY.ESC) {
	                    e.preventDefault();
	                    e.stopPropagation();
	                }
	
	            });
	
	            ctrl.searchInput.on('paste', function(e) {
	                var data;
	
	                if (window.clipboardData && window.clipboardData.getData) { // IE
	                    data = window.clipboardData.getData('Text');
	                } else {
	                    data = (e.originalEvent || e).clipboardData.getData('text/plain');
	                }
	
	                // Prepend the current input field text to the paste buffer.
	                data = ctrl.search + data;
	
	                if (data && data.length > 0) {
	                    // If tagging try to split by tokens and add items
	                    if (ctrl.taggingTokens.isActivated) {
	                        var items = [];
	                        for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) { // split by first token that is contained in data
	                            var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
	                            if (data.indexOf(separator) > -1) {
	                                items = data.split(separator);
	                                break; // only split by one token
	                            }
	                        }
	                        if (items.length === 0) {
	                            items = [data];
	                        }
	                        var oldsearch = ctrl.search;
	                        angular.forEach(items, function(item) {
	                            var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
	                            if (newItem) {
	                                ctrl.select(newItem, true);
	                            }
	                        });
	                        ctrl.search = oldsearch || EMPTY_SEARCH;
	                        e.preventDefault();
	                        e.stopPropagation();
	                    } else if (ctrl.paste) {
	                        ctrl.paste(data);
	                        ctrl.search = EMPTY_SEARCH;
	                        e.preventDefault();
	                        e.stopPropagation();
	                    }
	                }
	            });
	
	            ctrl.searchInput.on('tagged', function() {
	                $timeout(function() {
	                    _resetSearchInput();
	                });
	            });
	
	            // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
	            function _ensureHighlightVisible() {
	                var container = $element.querySelectorAll('.ui-select-choices-content');
	                var choices = container.querySelectorAll('.ui-select-choices-row');
	                if (choices.length < 1) {
	                    throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
	                }
	
	                if (ctrl.activeIndex < 0) {
	                    return;
	                }
	
	                var highlighted = choices[ctrl.activeIndex];
	                var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
	                var height = container[0].offsetHeight;
	
	                if (posY > height) {
	                    container[0].scrollTop += posY - height;
	                } else if (posY < highlighted.clientHeight) {
	                    if (ctrl.isGrouped && ctrl.activeIndex === 0)
	                        container[0].scrollTop = 0; //To make group header visible when going all the way up
	                    else
	                        container[0].scrollTop -= highlighted.clientHeight - posY;
	                }
	            }
	
	            var onResize = $$uisDebounce(function() {
	                ctrl.sizeSearchInput();
	            }, 50);
	
	            angular.element($window).bind('resize', onResize);
	
	            $scope.$on('$destroy', function() {
	                ctrl.searchInput.off('keyup keydown tagged blur paste');
	                angular.element($window).off('resize', onResize);
	            });
	
	            $scope.$watch('$select.activeIndex', function(activeIndex) {
	                if (activeIndex)
	                    $element.find('input').attr(
	                        'aria-activedescendant',
	                        'ui-select-choices-row-' + ctrl.generatedId + '-' + activeIndex);
	            });
	
	            $scope.$watch('$select.open', function(open) {
	                if (!open)
	                    $element.find('input').removeAttr('aria-activedescendant');
	            });
	        }
	    ]);
	
	    uis.directive('uiSelect', ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout',
	        function($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
	
	            return {
	                restrict: 'EA',
	                templateUrl: function(tElement, tAttrs) {
	                    var theme = tAttrs.theme || uiSelectConfig.theme;
	                    return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
	                },
	                replace: true,
	                transclude: true,
	                require: ['uiSelect', '^ngModel'],
	                scope: true,
	
	                controller: 'uiSelectCtrl',
	                controllerAs: '$select',
	                compile: function(tElement, tAttrs) {
	
	                    // Allow setting ngClass on uiSelect
	                    var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
	                    if (match) {
	                        var combined = '{' + match[1] + ', ' + match[2] + '}';
	                        tAttrs.ngClass = combined;
	                        tElement.attr('ng-class', combined);
	                    }
	
	                    //Multiple or Single depending if multiple attribute presence
	                    if (angular.isDefined(tAttrs.multiple))
	                        tElement.append('<ui-select-multiple/>').removeAttr('multiple');
	                    else
	                        tElement.append('<ui-select-single/>');
	
	                    if (tAttrs.inputId)
	                        tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
	
	                    return function(scope, element, attrs, ctrls, transcludeFn) {
	
	                        var $select = ctrls[0];
	                        var ngModel = ctrls[1];
	
	                        $select.generatedId = uiSelectConfig.generateId();
	                        $select.baseTitle = attrs.title || 'Select box';
	                        $select.focusserTitle = $select.baseTitle + ' focus';
	                        $select.focusserId = 'focusser-' + $select.generatedId;
	
	                        $select.closeOnSelect = function() {
	                            if (angular.isDefined(attrs.closeOnSelect)) {
	                                return $parse(attrs.closeOnSelect)();
	                            } else {
	                                return uiSelectConfig.closeOnSelect;
	                            }
	                        }();
	
	                        scope.$watch('skipFocusser', function() {
	                            var skipFocusser = scope.$eval(attrs.skipFocusser);
	                            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
	                        });
	
	                        $select.onSelectCallback = $parse(attrs.onSelect);
	                        $select.onRemoveCallback = $parse(attrs.onRemove);
	
	                        //Set reference to ngModel from uiSelectCtrl
	                        $select.ngModel = ngModel;
	
	                        $select.choiceGrouped = function(group) {
	                            return $select.isGrouped && group && group.name;
	                        };
	
	                        if (attrs.tabindex) {
	                            attrs.$observe('tabindex', function(value) {
	                                $select.focusInput.attr('tabindex', value);
	                                element.removeAttr('tabindex');
	                            });
	                        }
	
	                        scope.$watch(function() { return scope.$eval(attrs.searchEnabled); }, function(newVal) {
	                            $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
	                        });
	
	                        scope.$watch('sortable', function() {
	                            var sortable = scope.$eval(attrs.sortable);
	                            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
	                        });
	
	                        attrs.$observe('backspaceReset', function() {
	                            // $eval() is needed otherwise we get a string instead of a boolean
	                            var backspaceReset = scope.$eval(attrs.backspaceReset);
	                            $select.backspaceReset = backspaceReset !== undefined ? backspaceReset : true;
	                        });
	
	                        attrs.$observe('limit', function() {
	                            //Limit the number of selections allowed
	                            $select.limit = (angular.isDefined(attrs.limit)) ? parseInt(attrs.limit, 10) : undefined;
	                        });
	
	                        scope.$watch('removeSelected', function() {
	                            var removeSelected = scope.$eval(attrs.removeSelected);
	                            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
	                        });
	
	                        attrs.$observe('disabled', function() {
	                            // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
	                            $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
	                        });
	
	                        attrs.$observe('allowFreeText', function(allowFreeText) {
	                            // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
	                            $select.allowFreeText = (angular.isDefined(allowFreeText)) ? (allowFreeText === '') ? true : (allowFreeText.toLowerCase() === 'true') : false;
	                        });
	
	                        attrs.$observe('resetSearchInput', function() {
	                            // $eval() is needed otherwise we get a string instead of a boolean
	                            var resetSearchInput = scope.$eval(attrs.resetSearchInput);
	                            $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
	                        });
	
	                        attrs.$observe('paste', function() {
	                            $select.paste = scope.$eval(attrs.paste);
	                        });
	
	                        attrs.$observe('tagging', function() {
	                            if (attrs.tagging !== undefined) {
	                                // $eval() is needed otherwise we get a string instead of a boolean
	                                var taggingEval = scope.$eval(attrs.tagging);
	                                $select.tagging = { isActivated: true, fct: taggingEval !== true ? taggingEval : undefined };
	                            } else {
	                                $select.tagging = { isActivated: false, fct: undefined };
	                            }
	                        });
	
	                        attrs.$observe('taggingLabel', function() {
	                            if (attrs.tagging !== undefined) {
	                                // check eval for FALSE, in this case, we disable the labels
	                                // associated with tagging
	                                if (attrs.taggingLabel === 'false') {
	                                    $select.taggingLabel = false;
	                                } else {
	                                    $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
	                                }
	                            }
	                        });
	
	                        attrs.$observe('taggingTokens', function() {
	                            if (attrs.tagging !== undefined) {
	                                var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',', 'ENTER'];
	                                $select.taggingTokens = { isActivated: true, tokens: tokens };
	                            }
	                        });
	
	                        attrs.$observe('spinnerEnabled', function() {
	                            // $eval() is needed otherwise we get a string instead of a boolean
	                            var spinnerEnabled = scope.$eval(attrs.spinnerEnabled);
	                            $select.spinnerEnabled = spinnerEnabled !== undefined ? spinnerEnabled : uiSelectConfig.spinnerEnabled;
	                        });
	
	                        attrs.$observe('spinnerClass', function() {
	                            var spinnerClass = attrs.spinnerClass;
	                            $select.spinnerClass = spinnerClass !== undefined ? attrs.spinnerClass : uiSelectConfig.spinnerClass;
	                        });
	
	                        //Automatically gets focus when loaded
	                        if (angular.isDefined(attrs.autofocus)) {
	                            $timeout(function() {
	                                $select.setFocus();
	                            });
	                        }
	
	                        //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
	                        if (angular.isDefined(attrs.focusOn)) {
	                            scope.$on(attrs.focusOn, function() {
	                                $timeout(function() {
	                                    $select.setFocus();
	                                });
	                            });
	                        }
	
	                        function onDocumentClick(e) {
	                            if (!$select.open) return; //Skip it if dropdown is close
	
	                            var contains = false;
	
	                            if (window.jQuery) {
	                                // Firefox 3.6 does not support element.contains()
	                                // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
	                                contains = window.jQuery.contains(element[0], e.target);
	                            } else {
	                                contains = element[0].contains(e.target);
	                            }
	
	                            if (!contains && !$select.clickTriggeredSelect) {
	                                var skipFocusser;
	                                if (!$select.skipFocusser) {
	                                    //Will lose focus only with certain targets
	                                    var focusableControls = ['input', 'button', 'textarea', 'select'];
	                                    var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
	                                    skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
	                                    if (!skipFocusser) skipFocusser = ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
	                                } else {
	                                    skipFocusser = true;
	                                }
	                                $select.close(skipFocusser);
	                                scope.$digest();
	                            }
	                            $select.clickTriggeredSelect = false;
	                        }
	
	                        // See Click everywhere but here event http://stackoverflow.com/questions/12931369
	                        $document.on('click', onDocumentClick);
	
	                        scope.$on('$destroy', function() {
	                            $document.off('click', onDocumentClick);
	                        });
	
	                        // Move transcluded elements to their correct position in main template
	                        transcludeFn(scope, function(clone) {
	                            // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html
	
	                            // One day jqLite will be replaced by jQuery and we will be able to write:
	                            // var transcludedElement = clone.filter('.my-class')
	                            // instead of creating a hackish DOM element:
	                            var transcluded = angular.element('<div>').append(clone);
	
	                            var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
	                            transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
	                            transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
	                            if (transcludedMatch.length !== 1) {
	                                throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
	                            }
	                            element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
	
	                            var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
	                            transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
	                            transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
	                            if (transcludedChoices.length !== 1) {
	                                throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
	                            }
	                            element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
	
	                            var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
	                            transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
	                            transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
	                            if (transcludedNoChoice.length == 1) {
	                                element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
	                            }
	                        });
	
	                        // Support for appending the select field to the body when its open
	                        var appendToBody = scope.$eval(attrs.appendToBody);
	                        if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
	                            scope.$watch('$select.open', function(isOpen) {
	                                if (isOpen) {
	                                    positionDropdown();
	                                } else {
	                                    resetDropdown();
	                                }
	                            });
	
	                            // Move the dropdown back to its original location when the scope is destroyed. Otherwise
	                            // it might stick around when the user routes away or the select field is otherwise removed
	                            scope.$on('$destroy', function() {
	                                resetDropdown();
	                            });
	                        }
	
	                        // Hold on to a reference to the .ui-select-container element for appendToBody support
	                        var placeholder = null,
	                            originalWidth = '';
	
	                        function positionDropdown() {
	                            // Remember the absolute position of the element
	                            var offset = uisOffset(element);
	
	                            // Clone the element into a placeholder element to take its original place in the DOM
	                            placeholder = angular.element('<div class="ui-select-placeholder"></div>');
	                            placeholder[0].style.width = offset.width + 'px';
	                            placeholder[0].style.height = offset.height + 'px';
	                            element.after(placeholder);
	
	                            // Remember the original value of the element width inline style, so it can be restored
	                            // when the dropdown is closed
	                            originalWidth = element[0].style.width;
	
	                            // Now move the actual dropdown element to the end of the body
	                            $document.find('body').append(element);
	
	                            element[0].style.position = 'absolute';
	                            element[0].style.left = offset.left + 'px';
	                            element[0].style.top = offset.top + 'px';
	                            element[0].style.width = offset.width + 'px';
	                        }
	
	                        function resetDropdown() {
	                            if (placeholder === null) {
	                                // The dropdown has not actually been display yet, so there's nothing to reset
	                                return;
	                            }
	
	                            // Move the dropdown element back to its original location in the DOM
	                            placeholder.replaceWith(element);
	                            placeholder = null;
	
	                            element[0].style.position = '';
	                            element[0].style.left = '';
	                            element[0].style.top = '';
	                            element[0].style.width = originalWidth;
	
	                            // Set focus back on to the moved element
	                            $select.setFocus();
	                        }
	
	                        // Hold on to a reference to the .ui-select-dropdown element for direction support.
	                        var dropdown = null,
	                            directionUpClassName = 'direction-up';
	
	                        // Support changing the direction of the dropdown if there isn't enough space to render it.
	                        scope.$watch('$select.open', function() {
	
	                            if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up') {
	                                scope.calculateDropdownPos();
	                            }
	
	                        });
	
	                        var setDropdownPosUp = function(offset, offsetDropdown) {
	
	                            offset = offset || uisOffset(element);
	                            offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	                            dropdown[0].style.position = 'absolute';
	                            dropdown[0].style.top = (offsetDropdown.height * -1) + 'px';
	                            element.addClass(directionUpClassName);
	
	                        };
	
	                        var setDropdownPosDown = function(offset, offsetDropdown) {
	
	                            element.removeClass(directionUpClassName);
	
	                            offset = offset || uisOffset(element);
	                            offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	                            dropdown[0].style.position = '';
	                            dropdown[0].style.top = '';
	
	                        };
	
	                        var calculateDropdownPosAfterAnimation = function() {
	                            // Delay positioning the dropdown until all choices have been added so its height is correct.
	                            $timeout(function() {
	                                if ($select.dropdownPosition === 'up') {
	                                    //Go UP
	                                    setDropdownPosUp();
	                                } else {
	                                    //AUTO
	                                    element.removeClass(directionUpClassName);
	
	                                    var offset = uisOffset(element);
	                                    var offsetDropdown = uisOffset(dropdown);
	
	                                    //https://code.google.com/p/chromium/issues/detail?id=342307#c4
	                                    var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).
	
	                                    // Determine if the direction of the dropdown needs to be changed.
	                                    if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
	                                        //Go UP
	                                        setDropdownPosUp(offset, offsetDropdown);
	                                    } else {
	                                        //Go DOWN
	                                        setDropdownPosDown(offset, offsetDropdown);
	                                    }
	                                }
	
	                                // Display the dropdown once it has been positioned.
	                                dropdown[0].style.opacity = 1;
	                            });
	                        };
	
	                        var opened = false;
	
	                        scope.calculateDropdownPos = function() {
	                            if ($select.open) {
	                                dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
	
	                                if (dropdown.length === 0) {
	                                    return;
	                                }
	
	                                // Hide the dropdown so there is no flicker until $timeout is done executing.
	                                if ($select.search === '' && !opened) {
	                                    dropdown[0].style.opacity = 0;
	                                    opened = true;
	                                }
	
	                                if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
	                                    var needsCalculated = true;
	
	                                    $select.$animate.on('enter', dropdown, function(elem, phase) {
	                                        if (phase === 'close' && needsCalculated) {
	                                            calculateDropdownPosAfterAnimation();
	                                            needsCalculated = false;
	                                        }
	                                    });
	                                } else {
	                                    calculateDropdownPosAfterAnimation();
	                                }
	                            } else {
	                                if (dropdown === null || dropdown.length === 0) {
	                                    return;
	                                }
	
	                                // Reset the position of the dropdown.
	                                dropdown[0].style.opacity = 0;
	                                dropdown[0].style.position = '';
	                                dropdown[0].style.top = '';
	                                element.removeClass(directionUpClassName);
	                            }
	                        };
	                    };
	                }
	            };
	        }
	    ]);
	
	    uis.directive('uiSelectMatch', ['uiSelectConfig', function(uiSelectConfig) {
	        return {
	            restrict: 'EA',
	            require: '^uiSelect',
	            replace: true,
	            transclude: true,
	            templateUrl: function(tElement) {
	                // Needed so the uiSelect can detect the transcluded content
	                tElement.addClass('ui-select-match');
	
	                var parent = tElement.parent();
	                // Gets theme attribute from parent (ui-select)
	                var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
	                var multi = angular.isDefined(getAttribute(parent, 'multiple'));
	
	                return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');
	            },
	            link: function(scope, element, attrs, $select) {
	                $select.lockChoiceExpression = attrs.uiLockChoice;
	                attrs.$observe('placeholder', function(placeholder) {
	                    $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
	                });
	
	                function setAllowClear(allow) {
	                    $select.allowClear = (angular.isDefined(allow)) ? (allow === '') ? true : (allow.toLowerCase() === 'true') : false;
	                }
	
	                attrs.$observe('allowClear', setAllowClear);
	                setAllowClear(attrs.allowClear);
	
	                if ($select.multiple) {
	                    $select.sizeSearchInput();
	                }
	
	            }
	        };
	
	        function getAttribute(elem, attribute) {
	            if (elem[0].hasAttribute(attribute))
	                return elem.attr(attribute);
	
	            if (elem[0].hasAttribute('data-' + attribute))
	                return elem.attr('data-' + attribute);
	
	            if (elem[0].hasAttribute('x-' + attribute))
	                return elem.attr('x-' + attribute);
	        }
	    }]);
	
	    uis.directive('uiSelectMultiple', ['uiSelectMinErr', '$timeout', function(uiSelectMinErr, $timeout) {
	        return {
	            restrict: 'EA',
	            require: ['^uiSelect', '^ngModel'],
	
	            controller: ['$scope', '$timeout', function($scope, $timeout) {
	
	                var ctrl = this,
	                    $select = $scope.$select,
	                    ngModel;
	
	                if (angular.isUndefined($select.selected))
	                    $select.selected = [];
	
	                //Wait for link fn to inject it
	                $scope.$evalAsync(function() { ngModel = $scope.ngModel; });
	
	                ctrl.activeMatchIndex = -1;
	
	                ctrl.updateModel = function() {
	                    ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
	                    ctrl.refreshComponent();
	                };
	
	                ctrl.refreshComponent = function() {
	                    //Remove already selected items
	                    //e.g. When user clicks on a selection, the selected array changes and
	                    //the dropdown should remove that item
	                    if ($select.refreshItems) {
	                        $select.refreshItems();
	                    }
	                    if ($select.sizeSearchInput) {
	                        $select.sizeSearchInput();
	                    }
	                };
	
	                // Remove item from multiple select
	                ctrl.removeChoice = function(index) {
	
	                    // if the choice is locked, don't remove it
	                    if ($select.isLocked(null, index)) return false;
	
	                    var removedChoice = $select.selected[index];
	
	                    var locals = {};
	                    locals[$select.parserResult.itemName] = removedChoice;
	
	                    $select.selected.splice(index, 1);
	                    ctrl.activeMatchIndex = -1;
	                    $select.sizeSearchInput();
	
	                    // Give some time for scope propagation.
	                    $timeout(function() {
	                        $select.onRemoveCallback($scope, {
	                            $item: removedChoice,
	                            $model: $select.parserResult.modelMapper($scope, locals)
	                        });
	                    });
	
	                    ctrl.updateModel();
	
	                    return true;
	                };
	
	                ctrl.getPlaceholder = function() {
	                    //Refactor single?
	                    if ($select.selected && $select.selected.length) return;
	                    return $select.placeholder;
	                };
	
	
	            }],
	            controllerAs: '$selectMultiple',
	
	            link: function(scope, element, attrs, ctrls) {
	
	                var $select = ctrls[0];
	                var ngModel = scope.ngModel = ctrls[1];
	                var $selectMultiple = scope.$selectMultiple;
	
	                //$select.selected = raw selected objects (ignoring any property binding)
	
	                $select.multiple = true;
	
	                //Input that will handle focus
	                $select.focusInput = $select.searchInput;
	
	                //Properly check for empty if set to multiple
	                ngModel.$isEmpty = function(value) {
	                    return !value || value.length === 0;
	                };
	
	                //From view --> model
	                ngModel.$parsers.unshift(function() {
	                    var locals = {},
	                        result,
	                        resultMultiple = [];
	                    for (var j = $select.selected.length - 1; j >= 0; j--) {
	                        locals = {};
	                        locals[$select.parserResult.itemName] = $select.selected[j];
	                        result = $select.parserResult.modelMapper(scope, locals);
	                        resultMultiple.unshift(result);
	                    }
	                    return resultMultiple;
	                });
	
	                // From model --> view
	                ngModel.$formatters.unshift(function(inputValue) {
	                    var data = $select.parserResult && $select.parserResult.source(scope, { $select: { search: '' } }), //Overwrite $search
	                        locals = {},
	                        result;
	                    if (!data) return inputValue;
	                    var resultMultiple = [];
	                    var checkFnMultiple = function(list, value) {
	                        if (!list || !list.length) return;
	                        for (var p = list.length - 1; p >= 0; p--) {
	                            locals[$select.parserResult.itemName] = list[p];
	                            result = $select.parserResult.modelMapper(scope, locals);
	                            if ($select.parserResult.trackByExp) {
	                                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
	                                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
	                                if (propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName) {
	                                    if (matches && matches.length > 0 && result[matches[1]] == value[matches[1]]) {
	                                        resultMultiple.unshift(list[p]);
	                                        return true;
	                                    }
	                                }
	                            }
	                            if (angular.equals(result, value)) {
	                                resultMultiple.unshift(list[p]);
	                                return true;
	                            }
	                        }
	                        return false;
	                    };
	                    if (!inputValue) return resultMultiple; //If ngModel was undefined
	                    for (var k = inputValue.length - 1; k >= 0; k--) {
	                        //Check model array of currently selected items
	                        if (!checkFnMultiple($select.selected, inputValue[k])) {
	                            //Check model array of all items available
	                            if (!checkFnMultiple(data, inputValue[k])) {
	                                //If not found on previous lists, just add it directly to resultMultiple
	                                resultMultiple.unshift(inputValue[k]);
	                            }
	                        }
	                    }
	                    return resultMultiple;
	                });
	
	                //Watch for external model changes
	                scope.$watchCollection(function() { return ngModel.$modelValue; }, function(newValue, oldValue) {
	                    if (oldValue != newValue) {
	                        //update the view value with fresh data from items, if there is a valid model value
	                        if (angular.isDefined(ngModel.$modelValue)) {
	                            ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	                        }
	                        $selectMultiple.refreshComponent();
	                    }
	                });
	
	                ngModel.$render = function() {
	                    // Make sure that model value is array
	                    if (!angular.isArray(ngModel.$viewValue)) {
	                        // Have tolerance for null or undefined values
	                        if (isNil(ngModel.$viewValue)) {
	                            ngModel.$viewValue = [];
	                        } else {
	                            throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
	                        }
	                    }
	                    $select.selected = ngModel.$viewValue;
	                    $selectMultiple.refreshComponent();
	                    scope.$evalAsync(); //To force $digest
	                };
	
	                scope.$on('uis:select', function(event, item) {
	                    if ($select.selected.length >= $select.limit) {
	                        return;
	                    }
	                    $select.selected.push(item);
	                    var locals = {};
	                    locals[$select.parserResult.itemName] = item;
	
	                    $timeout(function() {
	                        $select.onSelectCallback(scope, {
	                            $item: item,
	                            $model: $select.parserResult.modelMapper(scope, locals)
	                        });
	                    });
	                    $selectMultiple.updateModel();
	                });
	
	                scope.$on('uis:activate', function() {
	                    $selectMultiple.activeMatchIndex = -1;
	                });
	
	                scope.$watch('$select.disabled', function(newValue, oldValue) {
	                    // As the search input field may now become visible, it may be necessary to recompute its size
	                    if (oldValue && !newValue) $select.sizeSearchInput();
	                });
	
	                $select.searchInput.on('keydown', function(e) {
	                    var key = e.which;
	                    scope.$apply(function() {
	                        var processed = false;
	                        // var tagged = false; //Checkme
	                        if (KEY.isHorizontalMovement(key)) {
	                            processed = _handleMatchSelection(key);
	                        }
	                        if (processed && key != KEY.TAB) {
	                            //TODO Check si el tab selecciona aun correctamente
	                            //Crear test
	                            e.preventDefault();
	                            e.stopPropagation();
	                        }
	                    });
	                });
	
	                function _getCaretPosition(el) {
	                    if (angular.isNumber(el.selectionStart)) return el.selectionStart;
	                    // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
	                    else return el.value.length;
	                }
	                // Handles selected options in "multiple" mode
	                function _handleMatchSelection(key) {
	                    var caretPosition = _getCaretPosition($select.searchInput[0]),
	                        length = $select.selected.length,
	                        // none  = -1,
	                        first = 0,
	                        last = length - 1,
	                        curr = $selectMultiple.activeMatchIndex,
	                        next = $selectMultiple.activeMatchIndex + 1,
	                        prev = $selectMultiple.activeMatchIndex - 1,
	                        newIndex = curr;
	
	                    if (caretPosition > 0 || ($select.search.length && key == KEY.RIGHT)) return false;
	
	                    $select.close();
	
	                    function getNewActiveMatchIndex() {
	                        switch (key) {
	                            case KEY.LEFT:
	                                // Select previous/first item
	                                if (~$selectMultiple.activeMatchIndex) return prev;
	                                // Select last item
	                                else return last;
	                                break;
	                            case KEY.RIGHT:
	                                // Open drop-down
	                                if (!~$selectMultiple.activeMatchIndex || curr === last) {
	                                    $select.activate();
	                                    return false;
	                                }
	                                // Select next/last item
	                                else return next;
	                                break;
	                            case KEY.BACKSPACE:
	                                // Remove selected item and select previous/first
	                                if (~$selectMultiple.activeMatchIndex) {
	                                    if ($selectMultiple.removeChoice(curr)) {
	                                        return prev;
	                                    } else {
	                                        return curr;
	                                    }
	
	                                } else {
	                                    // If nothing yet selected, select last item
	                                    return last;
	                                }
	                                break;
	                            case KEY.DELETE:
	                                // Remove selected item and select next item
	                                if (~$selectMultiple.activeMatchIndex) {
	                                    $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
	                                    return curr;
	                                } else return false;
	                        }
	                    }
	
	                    newIndex = getNewActiveMatchIndex();
	
	                    if (!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;
	                    else $selectMultiple.activeMatchIndex = Math.min(last, Math.max(first, newIndex));
	
	                    return true;
	                }
	
	                $select.searchInput.on('keyup', function(e) {
	
	                    if (!KEY.isVerticalMovement(e.which)) {
	                        scope.$evalAsync(function() {
	                            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	                        });
	                    }
	                    // Push a "create new" item into array if there is a search string
	                    if ($select.tagging.isActivated && $select.search.length > 0) {
	
	                        // return early with these keys
	                        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which)) {
	                            return;
	                        }
	                        // always reset the activeIndex to the first item when tagging
	                        $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	                        // taggingLabel === false bypasses all of this
	                        if ($select.taggingLabel === false) return;
	
	                        var items = angular.copy($select.items);
	                        var stashArr = angular.copy($select.items);
	                        var newItem;
	                        var item;
	                        var hasTag = false;
	                        var dupeIndex = -1;
	                        var tagItems;
	                        var tagItem;
	
	                        // case for object tagging via transform `$select.tagging.fct` function
	                        if ($select.tagging.fct !== undefined) {
	                            tagItems = $select.$filter('filter')(items, { 'isTag': true });
	                            if (tagItems.length > 0) {
	                                tagItem = tagItems[0];
	                            }
	                            // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
	                            if (items.length > 0 && tagItem) {
	                                hasTag = true;
	                                items = items.slice(1, items.length);
	                                stashArr = stashArr.slice(1, stashArr.length);
	                            }
	                            newItem = $select.tagging.fct($select.search);
	                            // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
	                            if (
	                                stashArr.some(function(origItem) {
	                                    return angular.equals(origItem, newItem);
	                                }) ||
	                                $select.selected.some(function(origItem) {
	                                    return angular.equals(origItem, newItem);
	                                })
	                            ) {
	                                scope.$evalAsync(function() {
	                                    $select.activeIndex = 0;
	                                    $select.items = items;
	                                });
	                                return;
	                            }
	                            if (newItem) newItem.isTag = true;
	                            // handle newItem string and stripping dupes in tagging string context
	                        } else {
	                            // find any tagging items already in the $select.items array and store them
	                            tagItems = $select.$filter('filter')(items, function(item) {
	                                return item.match($select.taggingLabel);
	                            });
	                            if (tagItems.length > 0) {
	                                tagItem = tagItems[0];
	                            }
	                            item = items[0];
	                            // remove existing tag item if found (should only ever be one tag item)
	                            if (item !== undefined && items.length > 0 && tagItem) {
	                                hasTag = true;
	                                items = items.slice(1, items.length);
	                                stashArr = stashArr.slice(1, stashArr.length);
	                            }
	                            newItem = $select.search + ' ' + $select.taggingLabel;
	                            if (_findApproxDupe($select.selected, $select.search) > -1) {
	                                return;
	                            }
	                            // verify the the tag doesn't match the value of an existing item from
	                            // the searched data set or the items already selected
	                            if (_findCaseInsensitiveDupe(stashArr.concat($select.selected))) {
	                                // if there is a tag from prev iteration, strip it / queue the change
	                                // and return early
	                                if (hasTag) {
	                                    items = stashArr;
	                                    scope.$evalAsync(function() {
	                                        $select.activeIndex = 0;
	                                        $select.items = items;
	                                    });
	                                }
	                                return;
	                            }
	                            if (_findCaseInsensitiveDupe(stashArr)) {
	                                // if there is a tag from prev iteration, strip it
	                                if (hasTag) {
	                                    $select.items = stashArr.slice(1, stashArr.length);
	                                }
	                                return;
	                            }
	                        }
	                        if (hasTag) dupeIndex = _findApproxDupe($select.selected, newItem);
	                        // dupe found, shave the first item
	                        if (dupeIndex > -1) {
	                            items = items.slice(dupeIndex + 1, items.length - 1);
	                        } else {
	                            items = [];
	                            if (newItem) items.push(newItem);
	                            items = items.concat(stashArr);
	                        }
	                        scope.$evalAsync(function() {
	                            $select.activeIndex = 0;
	                            $select.items = items;
	
	                            if ($select.isGrouped) {
	                                // update item references in groups, so that indexOf will work after angular.copy
	                                var itemsWithoutTag = newItem ? items.slice(1) : items;
	                                $select.setItemsFn(itemsWithoutTag);
	                                if (newItem) {
	                                    // add tag item as a new group
	                                    $select.items.unshift(newItem);
	                                    $select.groups.unshift({ name: '', items: [newItem], tagging: true });
	                                }
	                            }
	                        });
	                    }
	                });
	
	                function _findCaseInsensitiveDupe(arr) {
	                    if (arr === undefined || $select.search === undefined) {
	                        return false;
	                    }
	                    var hasDupe = arr.filter(function(origItem) {
	                        if ($select.search.toUpperCase() === undefined || origItem === undefined) {
	                            return false;
	                        }
	                        return origItem.toUpperCase() === $select.search.toUpperCase();
	                    }).length > 0;
	
	                    return hasDupe;
	                }
	
	                function _findApproxDupe(haystack, needle) {
	                    var dupeIndex = -1;
	                    if (angular.isArray(haystack)) {
	                        var tempArr = angular.copy(haystack);
	                        for (var i = 0; i < tempArr.length; i++) {
	                            // handle the simple string version of tagging
	                            if ($select.tagging.fct === undefined) {
	                                // search the array for the match
	                                if (tempArr[i] + ' ' + $select.taggingLabel === needle) {
	                                    dupeIndex = i;
	                                }
	                                // handle the object tagging implementation
	                            } else {
	                                var mockObj = tempArr[i];
	                                if (angular.isObject(mockObj)) {
	                                    mockObj.isTag = true;
	                                }
	                                if (angular.equals(mockObj, needle)) {
	                                    dupeIndex = i;
	                                }
	                            }
	                        }
	                    }
	                    return dupeIndex;
	                }
	
	                $select.searchInput.on('blur', function() {
	                    $timeout(function() {
	                        $selectMultiple.activeMatchIndex = -1;
	                    });
	                });
	
	            }
	        };
	    }]);
	
	    uis.directive('uiSelectNoChoice', ['uiSelectConfig', function(uiSelectConfig) {
	        return {
	            restrict: 'EA',
	            require: '^uiSelect',
	            replace: true,
	            transclude: true,
	            templateUrl: function(tElement) {
	                // Needed so the uiSelect can detect the transcluded content
	                tElement.addClass('ui-select-no-choice');
	
	                // Gets theme attribute from parent (ui-select)
	                var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	                return theme + '/no-choice.tpl.html';
	            }
	        };
	    }]);
	
	    uis.directive('uiSelectSingle', ['$timeout', '$compile', function($timeout, $compile) {
	        return {
	            restrict: 'EA',
	            require: ['^uiSelect', '^ngModel'],
	            link: function(scope, element, attrs, ctrls) {
	
	                var $select = ctrls[0];
	                var ngModel = ctrls[1];
	
	                //From view --> model
	                ngModel.$parsers.unshift(function(inputValue) {
	                    // Keep original value for undefined and null
	                    if (isNil(inputValue)) {
	                        return inputValue;
	                    }
	
	                    var locals = {},
	                        result;
	                    locals[$select.parserResult.itemName] = inputValue;
	                    result = $select.parserResult.modelMapper(scope, locals);
	                    return result;
	                });
	
	                //From model --> view
	                ngModel.$formatters.unshift(function(inputValue) {
	                    // Keep original value for undefined and null
	                    if (isNil(inputValue)) {
	                        return inputValue;
	                    }
	
	                    var data = $select.parserResult && $select.parserResult.source(scope, { $select: { search: '' } }), //Overwrite $search
	                        locals = {},
	                        result;
	                    if (data) {
	                        var checkFnSingle = function(d) {
	                            locals[$select.parserResult.itemName] = d;
	                            result = $select.parserResult.modelMapper(scope, locals);
	                            return result === inputValue;
	                        };
	                        //If possible pass same object stored in $select.selected
	                        if ($select.selected && checkFnSingle($select.selected)) {
	                            return $select.selected;
	                        }
	                        for (var i = data.length - 1; i >= 0; i--) {
	                            if (checkFnSingle(data[i])) return data[i];
	                        }
	                    }
	                    return inputValue;
	                });
	
	                //Update viewValue if model change
	                scope.$watch('$select.selected', function(newValue) {
	                    if (ngModel.$viewValue !== newValue) {
	                        ngModel.$setViewValue(newValue);
	                    }
	                });
	
	                ngModel.$render = function() {
	                    $select.selected = ngModel.$viewValue;
	                };
	
	                scope.$on('uis:select', function(event, item) {
	                    $select.selected = item;
	                    var locals = {};
	                    locals[$select.parserResult.itemName] = item;
	
	                    $timeout(function() {
	                        $select.onSelectCallback(scope, {
	                            $item: item,
	                            $model: isNil(item) ? item : $select.parserResult.modelMapper(scope, locals)
	                        });
	                    });
	                });
	
	                scope.$on('uis:close', function(event, skipFocusser) {
	                    $timeout(function() {
	                        $select.focusser.prop('disabled', false);
	                        if (!skipFocusser) $select.focusser[0].focus();
	                    }, 0, false);
	                });
	
	                scope.$on('uis:activate', function() {
	                    focusser.prop('disabled', true); //Will reactivate it on .close()
	                });
	
	                //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
	                var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
	                $compile(focusser)(scope);
	                $select.focusser = focusser;
	
	                //Input that will handle focus
	                $select.focusInput = focusser;
	
	                element.parent().append(focusser);
	                focusser.bind("focus", function() {
	                    scope.$evalAsync(function() {
	                        $select.focus = true;
	                    });
	                });
	                focusser.bind("blur", function() {
	                    scope.$evalAsync(function() {
	                        $select.focus = false;
	                    });
	                });
	                focusser.bind("keydown", function(e) {
	
	                    if (e.which === KEY.BACKSPACE && $select.backspaceReset !== false) {
	                        e.preventDefault();
	                        e.stopPropagation();
	                        $select.select(undefined);
	                        scope.$apply();
	                        return;
	                    }
	
	                    if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	                        return;
	                    }
	
	                    if (e.which == KEY.DOWN || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE) {
	                        e.preventDefault();
	                        e.stopPropagation();
	                        $select.activate();
	                    }
	
	                    scope.$digest();
	                });
	
	                focusser.bind("keyup input", function(e) {
	
	                    if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
	                        return;
	                    }
	
	                    $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
	                    focusser.val('');
	                    scope.$digest();
	
	                });
	
	
	            }
	        };
	    }]);
	
	    // Make multiple matches sortable
	    uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function($timeout, uiSelectConfig, uiSelectMinErr) {
	        return {
	            require: ['^^uiSelect', '^ngModel'],
	            link: function(scope, element, attrs, ctrls) {
	                if (scope[attrs.uiSelectSort] === null) {
	                    throw uiSelectMinErr('sort', 'Expected a list to sort');
	                }
	
	                var $select = ctrls[0];
	                var $ngModel = ctrls[1];
	
	                var options = angular.extend({
	                        axis: 'horizontal'
	                    },
	                    scope.$eval(attrs.uiSelectSortOptions));
	
	                var axis = options.axis;
	                var draggingClassName = 'dragging';
	                var droppingClassName = 'dropping';
	                var droppingBeforeClassName = 'dropping-before';
	                var droppingAfterClassName = 'dropping-after';
	
	                scope.$watch(function() {
	                    return $select.sortable;
	                }, function(newValue) {
	                    if (newValue) {
	                        element.attr('draggable', true);
	                    } else {
	                        element.removeAttr('draggable');
	                    }
	                });
	
	                element.on('dragstart', function(event) {
	                    element.addClass(draggingClassName);
	
	                    (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
	                });
	
	                element.on('dragend', function() {
	                    removeClass(draggingClassName);
	                });
	
	                var move = function(from, to) {
	                    /*jshint validthis: true */
	                    this.splice(to, 0, this.splice(from, 1)[0]);
	                };
	
	                var removeClass = function(className) {
	                    angular.forEach($select.$element.querySelectorAll('.' + className), function(el) {
	                        angular.element(el).removeClass(className);
	                    });
	                };
	
	                var dragOverHandler = function(event) {
	                    event.preventDefault();
	
	                    var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
	
	                    if (offset < (this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2)) {
	                        removeClass(droppingAfterClassName);
	                        element.addClass(droppingBeforeClassName);
	
	                    } else {
	                        removeClass(droppingBeforeClassName);
	                        element.addClass(droppingAfterClassName);
	                    }
	                };
	
	                var dropTimeout;
	
	                var dropHandler = function(event) {
	                    event.preventDefault();
	
	                    var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);
	
	                    // prevent event firing multiple times in firefox
	                    $timeout.cancel(dropTimeout);
	                    dropTimeout = $timeout(function() {
	                        _dropHandler(droppedItemIndex);
	                    }, 20);
	                };
	
	                var _dropHandler = function(droppedItemIndex) {
	                    var theList = scope.$eval(attrs.uiSelectSort);
	                    var itemToMove = theList[droppedItemIndex];
	                    var newIndex = null;
	
	                    if (element.hasClass(droppingBeforeClassName)) {
	                        if (droppedItemIndex < scope.$index) {
	                            newIndex = scope.$index - 1;
	                        } else {
	                            newIndex = scope.$index;
	                        }
	                    } else {
	                        if (droppedItemIndex < scope.$index) {
	                            newIndex = scope.$index;
	                        } else {
	                            newIndex = scope.$index + 1;
	                        }
	                    }
	
	                    move.apply(theList, [droppedItemIndex, newIndex]);
	
	                    $ngModel.$setViewValue(Date.now());
	
	                    scope.$apply(function() {
	                        scope.$emit('uiSelectSort:change', {
	                            array: theList,
	                            item: itemToMove,
	                            from: droppedItemIndex,
	                            to: newIndex
	                        });
	                    });
	
	                    removeClass(droppingClassName);
	                    removeClass(droppingBeforeClassName);
	                    removeClass(droppingAfterClassName);
	
	                    element.off('drop', dropHandler);
	                };
	
	                element.on('dragenter', function() {
	                    if (element.hasClass(draggingClassName)) {
	                        return;
	                    }
	
	                    element.addClass(droppingClassName);
	
	                    element.on('dragover', dragOverHandler);
	                    element.on('drop', dropHandler);
	                });
	
	                element.on('dragleave', function(event) {
	                    if (event.target != element) {
	                        return;
	                    }
	
	                    removeClass(droppingClassName);
	                    removeClass(droppingBeforeClassName);
	                    removeClass(droppingAfterClassName);
	
	                    element.off('dragover', dragOverHandler);
	                    element.off('drop', dropHandler);
	                });
	            }
	        };
	    }]);
	
	    /**
	     * Debounces functions
	     *
	     * Taken from UI Bootstrap $$debounce source code
	     * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
	     *
	     */
	    uis.factory('$$uisDebounce', ['$timeout', function($timeout) {
	        return function(callback, debounceTime) {
	            var timeoutPromise;
	
	            return function() {
	                var self = this;
	                var args = Array.prototype.slice.call(arguments);
	                if (timeoutPromise) {
	                    $timeout.cancel(timeoutPromise);
	                }
	
	                timeoutPromise = $timeout(function() {
	                    callback.apply(self, args);
	                }, debounceTime);
	            };
	        };
	    }]);
	
	    uis.directive('uisOpenClose', ['$parse', '$timeout', function($parse, $timeout) {
	        return {
	            restrict: 'A',
	            require: 'uiSelect',
	            link: function(scope, element, attrs, $select) {
	                $select.onOpenCloseCallback = $parse(attrs.uisOpenClose);
	
	                scope.$watch('$select.open', function(isOpen, previousState) {
	                    if (isOpen !== previousState) {
	                        $timeout(function() {
	                            $select.onOpenCloseCallback(scope, {
	                                isOpen: isOpen
	                            });
	                        });
	                    }
	                });
	            }
	        };
	    }]);
	
	    /**
	     * Parses "repeat" attribute.
	     *
	     * Taken from AngularJS ngRepeat source code
	     * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
	     *
	     * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
	     * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
	     */
	
	    uis.service('uisRepeatParser', ['uiSelectMinErr', '$parse', function(uiSelectMinErr, $parse) {
	        var self = this;
	
	        /**
	         * Example:
	         * expression = "address in addresses | filter: {street: $select.search} track by $index"
	         * itemName = "address",
	         * source = "addresses | filter: {street: $select.search}",
	         * trackByExp = "$index",
	         */
	        self.parse = function(expression) {
	
	
	            var match;
	            //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
	            // If an array is used as collection
	
	            // if (isObjectCollection){
	            // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
	            match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	            // 1 Alias
	            // 2 Item
	            // 3 Key on (key,value)
	            // 4 Value on (key,value)
	            // 5 Source expression (including filters)
	            // 6 Track by
	
	            if (!match) {
	                throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	                    expression);
	            }
	
	            var source = match[5],
	                filters = '';
	
	            // When using (key,value) ui-select requires filters to be extracted, since the object
	            // is converted to an array for $select.items
	            // (in which case the filters need to be reapplied)
	            if (match[3]) {
	                // Remove any enclosing parenthesis
	                source = match[5].replace(/(^\()|(\)$)/g, '');
	                // match all after | but not after ||
	                var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
	                if (filterMatch && filterMatch[1].trim()) {
	                    filters = filterMatch[1];
	                    source = source.replace(filters, '');
	                }
	            }
	
	            return {
	                itemName: match[4] || match[2], // (lhs) Left-hand side,
	                keyName: match[3], //for (key, value) syntax
	                source: $parse(source),
	                filters: filters,
	                trackByExp: match[6],
	                modelMapper: $parse(match[1] || match[4] || match[2]),
	                repeatExpression: function(grouped) {
	                    var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
	                    if (this.trackByExp) {
	                        expression += ' track by ' + this.trackByExp;
	                    }
	                    return expression;
	                }
	            };
	
	        };
	
	        self.getGroupNgRepeatExpression = function() {
	            return '$group in $select.groups track by $group.name';
	        };
	
	    }]);
	
	}());
	angular.module("ui.select").run(["$templateCache", function($templateCache) {
	    $templateCache.put("bootstrap/choices.tpl.html", "<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><span class=\"ui-select-choices-row-inner\"></span></div></li></ul>");
	    $templateCache.put("bootstrap/match-multiple.tpl.html", "<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
	    $templateCache.put("bootstrap/match.tpl.html", "<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
	    $templateCache.put("bootstrap/no-choice.tpl.html", "<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
	    $templateCache.put("bootstrap/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{$select.baseTitle}}\" ng-class=\"{\'spinner\': $select.refreshing}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	    $templateCache.put("bootstrap/select.tpl.html", "<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><span ng-show=\"$select.open && $select.refreshing && $select.spinnerEnabled\" class=\"ui-select-refreshing {{$select.spinnerClass}}\"></span> <input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" class=\"form-control ui-select-search\" ng-class=\"{ \'ui-select-search-hidden\' : !$select.searchEnabled }\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	    $templateCache.put("select2/choices.tpl.html", "<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
	    $templateCache.put("select2/match-multiple.tpl.html", "<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
	    $templateCache.put("select2/match.tpl.html", "<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
	    $templateCache.put("select2/no-choice.tpl.html", "<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	    $templateCache.put("select2/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
	    $templateCache.put("select2/select.tpl.html", "<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
	    $templateCache.put("selectize/choices.tpl.html", "<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown\" ng-class=\"{\'single\': !$select.multiple, \'multi\': $select.multiple}\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
	    $templateCache.put("selectize/match-multiple.tpl.html", "<div class=\"ui-select-match\" data-value=\"\" ng-repeat=\"$item in $select.selected track by $index\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'active\':$selectMultiple.activeMatchIndex === $index}\" ui-select-sort=\"$select.selected\"><span class=\"ui-select-match-item\" ng-class=\"{\'select-locked\':$select.isLocked(this, $index)}\"><span uis-transclude-append=\"\"></span> <span class=\"remove ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&times;</span></span></div>");
	    $templateCache.put("selectize/match.tpl.html", "<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\"><span ng-show=\"!$select.searchEnabled && ($select.isEmpty() || $select.open)\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude=\"\"></span></div>");
	    $templateCache.put("selectize/no-choice.tpl.html", "<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"selectize-dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	    $templateCache.put("selectize/select-multiple.tpl.html", "<div class=\"ui-select-container selectize-control multi plugin-remove_button\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-model=\"$select.search\" ng-disabled=\"$select.disabled\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	    $templateCache.put("selectize/select.tpl.html", "<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.isEmpty() && !$select.open\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	}]);

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(366);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(348)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(347)();
	// imports
	
	
	// module
	exports.push([module.id, "a,body,button,div,h1,h2,h3,h4,h5,h6,html,input,li,p{font-family:Roboto,sans-serif;transition:all .5s ease 0s}button:focus{outline:0!important}html{height:100%}body{min-height:100%;background:#f5f7fa}.full-height-element,body{display:flex;flex-direction:column}.full-height-element{flex:1}#wrap{background:#f5f7fa}.page-outer{width:62%;margin:4em auto}@media screen and (max-width:992px){.page-outer{width:99%}}.page{flex:1;background:#fff;border:.5px solid rgba(204,208,217,.5)}.glyphicon-ok{-webkit-text-stroke:2px #fff}product-list-item:hover .glyphicon-ok,product-media-list-item:hover .glyphicon-ok{-webkit-text-stroke:0!important}.mr-0{margin-right:0}.ml-0{margin-left:0}.mt-0{margin-top:0}.mb-0{margin-bottom:0}.p-0{padding:0}.pl-0{padding-left:0}.pr-0{padding-right:0}.pb-0{padding-bottom:0}.pt-0{padding-top:0}.pb-10{padding-bottom:10px}.pt-10{padding-top:10px}.pl-10{padding-left:10px}.pr-10{padding-right:10px}.pb-20{padding-bottom:20px}.pt-20{padding-top:20px}.pl-20{padding-left:20px}.pr-20{padding-right:20px}.mb-20{margin-bottom:20px}.mb-30{margin-bottom:30px}.mt-20{margin-top:20px}.mt-10{margin-top:10px}.mb-10{margin-bottom:10px}.mt-5{margin-top:5px}.mb-5{margin-bottom:5px}.p-40{padding:40px}@media (max-width:768px){.p-40{padding:10px}}.pl-50{padding-left:50px}.pr-50{padding-right:50px}.glyphicon-calendar:before{content:\"\";background:url(" + __webpack_require__(367) + ");background-size:100%;display:inline-block;width:20px;height:20px;margin-top:-2px}.glyphicon-calendar.invert{-webkit-filter:invert(1) brightness(2);-moz-filter:invert(1) brightness(2);-o-filter:invert(1) brightness(2);-ms-filter:invert(1) brightness(2);filter:invert(1) brightness(2)}.cancel-btn{height:35px;max-width:180px;border-radius:5px;background-color:#e3e7ea;color:#5c6b76;font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:.6px;border:none}.cancel-btn:hover{background-color:#cbced7;color:#fff;border:none}.cancel-btn:disabled{background-color:#e3e7ea;color:#fff;border:none}.clear-btn,.save-as-draft-btn{height:35px;border-radius:5px;border:1px solid #70b345;font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:center;background-color:#fff;color:#70b345}.clear-btn:hover,.save-as-draft-btn:hover{color:#fff;background-color:#70b345;border:none}.clear-btn:disabled,.save-as-draft-btn:disabled{border:1px solid #e2e6ea;color:#e2e6ea;background-color:#fff}.save-btn{height:35px;border-radius:5px;background-color:#70b345;font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#fff}.save-btn:hover{background-color:#9ed267;color:#fff;border:none}.save-btn:disabled{background-color:#e3e7ea;color:#fff;border:none}[class*=\" col-\"]>.cancel-btn{max-width:none}.confirm-delete-btn{width:180px;height:35px;border-radius:5px;background-color:#ff4e50;color:#fff;font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:.6px;border:none;border:1px solid #ff4e50}.confirm-delete-btn:hover{background-color:#fff;color:#ff4e50;border:1px solid #ff4e50}.confirm-delete-btn:disabled{background-color:#e3e7ea;color:#fff;border:none}.confirm-btn{width:180px;height:35px;border-radius:5px;background-color:#70b345;color:#fff;font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:.6px;border:none;border:1px solid #70b345}.confirm-btn:hover{background-color:#fff;color:#70b345;border:1px solid #70b345}.confirm-btn:disabled{background-color:#e3e7ea;color:#fff;border:none}::-webkit-input-placeholder{color:#aab2bd}::-moz-placeholder{color:#aab2bd}:-ms-input-placeholder{color:#aab2bd}:-moz-placeholder{color:#aab2bd}.modal-title{padding-top:20px;padding-bottom:10px;margin-left:25px;padding-left:0}.modal-header{padding-top:0;padding-bottom:5px;border-bottom:none}.modal-header button.close{padding-top:20px;padding-right:15px;font-size:25px!important;font-weight:300!important;opacity:1!important}.absolute-close{position:absolute;top:10px;right:20px;font-size:25px;font-weight:300;opacity:1;z-index:25}.modal-text{font-size:20px;font-weight:300;color:#2a3b44;padding:0 60px;margin-bottom:60px}.modal-body{border-top:1px solid #ccd0d9;padding:0}.modal-footer-spacing--large{padding:30px 0 40px}.modal-text--bigger{font-size:28px;font-weight:300;line-height:1.36;text-align:center;color:#4a5863}.modal-body-spacing{padding:40px}.modal-body-spacing--large{padding:165px 90px 100px}.modal-select-options{padding-left:47px;padding-right:65px;padding-bottom:100px!important}.modal-select-options .lead{margin:54px 0 50px;font-size:20px!important}.modal-select-options h4{font-size:20px;font-weight:400;color:#2a3b44}.modal-select-options .input-boxes{padding:38px 40px}.modal-select-options .input-boxes .checkbox-default-row.check-clear,.modal-select-options .input-boxes .checkbox-header-row.check-clear{padding-left:0;padding-right:0;margin-left:-3px}.modal-select-options .input-boxes .title-push-top{margin-top:45px}.modal-select-options-title{padding:0;width:49%}.modal-select-options-title:first-of-type{margin-right:2%}.modal-select-options-title h4{margin:0 0 26px}#export-modal .back-btn .glyphicon{float:left;margin-top:1px}.product-media-container{padding-left:40px;padding-right:40px;padding-top:20px;border-bottom:none}.product-media-container .title-20{padding-bottom:20px;margin-left:0;font-size:20px;font-weight:400;color:#2a3b44}.product-information-container{padding-top:20px;border-bottom:none}.product-information-container .title-20{padding-bottom:20px;margin-left:0;font-size:20px;font-weight:400;color:#2a3b44}.form-control:focus,input:focus{box-shadow:none;outline:0}.ui-select-container.ui-select-custom,.ui-select-custom .ui-select-match{outline:0!important;height:30px;background-color:#f5f7fa!important;color:#2a3b44;border-color:transparent;box-shadow:none}.ui-select-container.ui-select-custom input[type=search],.ui-select-custom .ui-select-match input[type=search]{color:#2a3b44;border:none;box-shadow:none;height:30px}.ui-select-container.ui-select-custom .ui-select-choices,.ui-select-custom .ui-select-match .ui-select-choices{padding:0;border:none;box-shadow:none}.sidebar-filter .ui-select-custom .ui-select-match{background:transparent!important}.ui-select-match-item{padding:4px 10px!important;border-radius:6px;border-color:transparent}.ui-select-match-item .close{font-weight:200;font-size:15px!important}.ui-select-custom .ui-select-choices-row{outline:0;height:35px;background-color:#f5f7fa!important;color:#2a3b44}.ui-select-custom.ui-select-bootstrap .ui-select-choices-row>span{padding:7px 14px!important}.ui-select-custom.ui-select-bootstrap .ui-select-choices-row.active>span,.ui-select-custom.ui-select-bootstrap .ui-select-choices-row:hover>span,.ui-select-custom.ui-select-bootstrap .ui-select-choices-row>span:focus,.ui-select-custom.ui-select-bootstrap .ui-select-choices-row>span:hover{background-color:#6bd2e1!important;color:#fff!important}.ui-select-custom .ui-select-toggle{height:30px;background-color:#f5f7fa!important;color:#2a3b44;border:none;box-shadow:none}.btn-default-focus{box-shadow:none!important}#view-product-container input[type=text],.form-input{height:30px;color:#2a3b44;border:none;box-shadow:none;background-color:#f5f7fa!important}.ui-select-match-close{color:#fff;padding-left:5px;opacity:1;font-weight:200;font-size:15px!important;line-height:.75}.ui-select-custom .chip{margin:0 3px 3px 0!important}.chip .ui-select-match-close{margin-top:5px}#container-shift .product-information-container .ui-select-custom input:not(.input-xs),#create-product-container .product-information-container .ui-select-custom input,#view-product-container .ui-select-custom input:not(.input-xs){border:1px solid #ccd0d9;background-color:#fff!important;border-radius:0}.dropdown-menu{border-radius:0}.ui-select-custom.ui-select-bootstrap>.ui-select-choices,.ui-select-custom.ui-select-bootstrap>.ui-select-no-choice{margin-top:0!important;box-shadow:0 0 4px 0 #aab2bd}input[type=radio]:checked.custom-check-input+.checkbox-custom-label:after{content:\"\";position:absolute;width:7px;height:7px;border-radius:7px;left:4px;top:6px;background-color:#6bd2e1}input[type=radio].custom-check-input{display:none}.checkbox-custom-label{display:block;position:relative;font-weight:300;z-index:9;margin-bottom:12px;cursor:pointer;-webkit-transition:all .25s linear;padding-left:20px;color:#2a3b44}.checkbox-custom-label:before{content:\"\";position:absolute;border-radius:15px;width:15px;height:15px;left:0;top:2px;border:1px solid #2a3b44}.section-title{font-weight:400;color:#2a3b44;font-size:20px}.calendar .dropdown-menu{padding:0}.calendar thead .btn{border:none;background:transparent;color:#fff}.calendar thead .uib-title{text-transform:uppercase}.calendar thead tr:first-of-type{background-color:#2ba7bc;height:35px}.calendar thead tr:last-of-type{background-color:#f5f7fa;height:25px}.calendar thead tr:last-of-type th small{font-size:10px;color:#2a3b44;text-transform:uppercase}.calendar tbody tr td .btn{border:none;font-size:10px;box-shadow:none;border-radius:100%}.calendar tbody tr td .btn.active{background-color:#2ba7bc;padding:5px 7px;min-width:auto}.calendar tbody tr td .btn.active span{color:#fff}.calendar tbody tr td .btn.btn-default:hover{background-color:#d4f2ff;padding:5px 7px;min-width:auto}.calendar tbody tr td .text-muted{color:#ccd0d9}.calendar tbody tr td:first-of-type{color:#6bd2e1;font-size:10px}.calendar tbody tr td:first-of-type em{font-style:normal}.calendar .uib-button-bar{background-color:#f5f7fa;height:30px;padding-top:5px;text-align:right}.calendar .uib-button-bar .btn-group{float:none!important}.calendar .uib-button-bar .btn{background:none;border-color:transparent;text-transform:uppercase;font-size:12px;padding:0;margin-right:10px}.calendar .uib-button-bar .btn.btn-info{color:#6bd2e1}.calendar .uib-button-bar .btn.btn-danger{color:#4a5863}.calendar .uib-button-bar .btn.btn-success{display:none}.block-ui-overlay{opacity:1;background-color:#2ba7bc}.block-ui-message{background-color:transparent}.loader{font-size:10px;margin:50px auto;text-indent:-9999em;width:11em;height:11em;border-radius:50%;background:#fff;background:linear-gradient(90deg,#fff 10%,hsla(0,0%,100%,0) 42%);position:relative;-webkit-animation:load3 1.4s infinite linear;animation:load3 1.4s infinite linear;-webkit-transform:translateZ(0);transform:translateZ(0)}.loader:before{width:50%;height:50%;background:#fff;border-radius:100% 0 0 0}.loader:after,.loader:before{position:absolute;top:0;left:0;content:\"\"}.loader:after{background:#2ba7bc;width:75%;height:75%;border-radius:50%;margin:auto;bottom:0;right:0}.search-title{margin-top:16px}.flex-container-centered{display:flex;align-items:center;justify-content:center;flex-direction:column;height:calc(100% - 112px)}.collection-clickable{cursor:pointer}.checkbox-list{padding-left:0}.checkbox.btn-default:focus,.checkbox.btn-default:hover{background-color:#fff}.checkbox-list>li{display:inline;list-style-type:none;float:left;padding-right:10px}.product-information-container{border-left:.5px solid rgba(204,208,217,.5)}.chevron-right-btn{border:none;background:none;text-align:right;padding-top:0;padding-bottom:0;color:#2a3b44}.chevron-right-btn:focus{outline:0!important}#container-shift div.list-group-item{padding:6px 15px 2px}#container-shift div.list-group-item:hover{background-color:#d4f2ff;opacity:.7}.delete-warning h3{margin:60px 20% 20px;font-size:28px;font-weight:300;line-height:1.57;text-align:center;color:#4a5863}.delete-warning h5{font-size:14px;color:#2a3b44;margin-bottom:60px}.tree-classic{width:400px;text-align:left}.tree-classic>ul{margin:20px}.tree-classic li{position:unset;transition:none!important;line-height:10px}.tree-classic .tree-selected{color:#fff;background-color:#6bd2e1;font-weight:400;opacity:.99;background-color:unset;z-index:2;transition:none!important}.tree-classic .tree-selected:before{content:\"\";width:100%;background-color:#6bd2e1;opacity:1;height:35px;margin-top:-8px;position:absolute;left:0;display:block;z-index:-1;transition:none!important}.tree-classic .tree-branch-head,.tree-classic .tree-leaf-head{position:relative;z-index:100;top:20px}.tree-classic .tree-expanded{color:#6bd2e1}.tree-classic .tree-expanded .tree-collapsed,.tree-classic .tree-expanded .tree-expanded{margin:0;height:auto}.tree-classic .tree-collapsed,.tree-classic .tree-leaf{color:#000;margin:0}.tree-classic .tree-leaf:first-child{margin-top:10px}.tree-classic .tree-label{line-height:20px}.tree-branch-head,.tree-leaf-head{background:transparent!important}.tree-branch-head{padding-left:500px!important}.tree-label{display:block!important;line-height:23px}.keywords-column{background-color:#fff;padding-bottom:50px}.keywords-column .glyphicon-minus,.keywords-column .glyphicon-plus{top:9px;right:10px;float:right;cursor:pointer;-webkit-text-stroke:2px #fff}.keyword-title{font-size:16px;color:#2a3b44;border-bottom:1px solid #ccd0d9;padding:4px 0 24px;font-weight:400}.keyword-subtitle{display:inline-block;font-weight:400}.eq-height-columns{display:flex;flex-wrap:wrap}.image-info-text{padding-bottom:8px;border-bottom:1px solid #ccd0d9}.pos-r{position:relative}#add-new-folder-link{color:#6bd2e1;position:absolute;top:16px;right:15px;z-index:5}.wrapper-container{max-width:1100px;margin-left:0}.btn-invert .glyphicon{line-height:.6px}.btn-invert .glyphicon.glyphicon-minus{-webkit-text-stroke:2.6px #4a5863;vertical-align:bottom!important;font-size:18px}.btn-invert .glyphicon.glyphicon-menu-down,.btn-invert .glyphicon.glyphicon-menu-up{-webkit-text-stroke:.5px #4a5863;font-size:16px}.btn-invert .glyphicon.glyphicon-remove{-webkit-text-stroke:2.6px #4a5863;font-size:18px}.small-title{font-size:16px;color:#aab2bd}#admin-view-product-container .form-control,#create-product-container .form-control{border-radius:0!important;background-color:#f5f7fa!important;border:none;box-shadow:none}#admin-view-product-container .product-information-container input,#create-product-container .product-information-container input{min-height:30px}.validation-message{font-size:10px;text-align:right;color:#ff4e50;padding-bottom:10px;clear:both}@-webkit-keyframes load3{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes load3{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ }),

/***/ 367:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// app.bundle.js